/*
 * Polyfills required for Babel (https://babeljs.io/docs/en/babel-polyfill/)
 */
import "@babel/polyfill";

/*
 * VENDOR & 3RD PARTY LIBS
*/
import $ from 'jquery';
// export for others scripts to use
window.$ = $;

import 'what-input';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
//import select2 from 'select2/dist/js/select2.full';
import Cookies from 'js-cookie';
window.Cookies = Cookies;

import LoadingOverlay from 'gasparesganga-jquery-loading-overlay';
//import Plyr from 'plyr';
// import './vendors/jquery.svg.min.js';
// import './vendors/jquery.svganim.min.js';

/**
 * this has been refactored out to the `lib/components/lot-map.js` file
 */
//import '@panzoom/panzoom';

import 'jquery-ui/dist/jquery-ui.js';
import lozad from 'lozad';
import { initMagellanModules } from "./magellan.js";

import { 
    initMediaWithThumbnailCarousel, 
    initMediaWithThumbnailCarousels, 
    initMediaCarousel 
} from "./modal-gallery-v2.js";
window.initMediaWithThumbnailCarousel = initMediaWithThumbnailCarousel;
window.initMediaCarousel = initMediaCarousel;

import { initWidenVideos } from "./lib/widen-media.js";

$(document).foundation();
initMagellanModules();
/*
 * GLOBAL VARIABLES. DECLARE BEFORE WEBSITE CUSTOM LIBS.
 */
var SERVICE_REQUEST_SAS_KEY_COOKIE = "srSasKey";
window.SERVICE_REQUEST_SAS_KEY_COOKIE = SERVICE_REQUEST_SAS_KEY_COOKIE;
var ACCESSIBILITY_COOKIE = "wcag";
var ACCESSIBILITY_ENABLED = "accessibility-styles-enabled";
var BODY_WCAG_CLASS = "wcag";
// Modals
var SIGNIN_MODAL_ID = "signin-modal";

/**
 * this has been refactored out to the `community-search.js` file
 */
// Region Communities Map + Listing Propertires
// var regionCommunitiesMap = null;
// var regionCommunitiesMapMarkers = [];
// var regionCommunitiesMapActiveInfoWindow = null;
// var regionCommunitiesMapClusterer = null;
// var regionCommunitiesMapClusterHoverListener = null;
// var REGION_COMMUNITIES_MAP_MIN_ZOOM = 12;
// var REGION_COMMUNITIES_MAP_MAX_ZOOM = 16;
// var regionCommunitiesMapApplyFilterSortClicked = false; // Flag to signal if the Apply Filter click was triggered by Sort dropdown change event listener

var IS_LOCALHOST = location.host.indexOf("localhost") >= 0;
var MARKETING_SITE_URL = "";
window.IS_LOCALHOST = IS_LOCALHOST;

var MSH_SITE_URL = (((typeof window.msh === 'undefined') || (typeof window.msh.siteUrl === 'undefined')) ? '/' : window.msh.siteUrl);
let iFrameScrollPos = 0;
let isScrollForIFrameSet = false;
const IFRAME_SCROLL_OFFSET = 0; // When positioning the page on fragmented URL's adding 300px to the scroll position seems to put everything in the correct place

/*
 * WEBSITE CUSTOM LIBS
 */
/**
 * this has been refactored out to the `lib/components/community-map.js` file
 */
//import MapHelper from './lib/MapHelper';
import './lib/favoriting';
/**
 * this has been refactored out to the `lib/components/lot-map.js` file
 */
//import LotMapHelper from './lib/LotMapHelper';
import { RenderPdfIframeHelper } from './lib/RenderPdfIframeHelper';
import { RenderHomesiteInformationHelper } from './lib/RenderHomesiteInformationHelper';
window.RenderHomesiteInformationHelper = RenderHomesiteInformationHelper;
import { RenderPdfObjectHelper } from './lib/RenderPdfObjectHelper';

import './lib/abide';
import './lib/abide-validate-input-file';
import './lib/abide-validate-field-type';
import './lib/abide-validate-radio-selection';
import './lib/abide-validate-state-selection';
import './lib/atlas-rtx-helper';
import './lib/sticky';
import './lib/plyr';
import './lib/reveal';
import './lib/media-gallery-block';
import './lib/gallery-hero';
import './lib/fyh-reveal-tabs';
import './lib/popup-promo-interestlist';
import './lib/drilldown';
/**
 * this has been refactored out to `mortgaga-calculator.js`
 */
//import './lib/MortgageCalculator';
import './lib/media-carousel';
/**
 * this has been refactored out to be reference in `find-your-home.js`
 */
//import './lib/fyh-filters'
import './lib/header';
import './lib/fyh-drilldown';
import './lib/intro-additional-content';
import './lib/print';
import './lib/address-verification';
/**
 * this has been refactored to `/lib/forms/form-more-info.js`
 */
// import MoreInfoFormHelper from './lib/MoreInfoFormHelper';
// window.MoreInfoFormHelper = MoreInfoFormHelper;
import './lib/datepicker';
import './lib/file-upload-validation.js';
import './lib/request-appointment-form';
import './lib/copy-paste';
import './lib/addthis-defaultconfig';
import './lib/onetrust-trigger';
import initCustomAccordion from './lib/modules/accordions.js'
window.initCustomAccordion = initCustomAccordion;

// MSH
import MshUser from "./lib/msh-user";
window.MshUser = MshUser;
MshUser.initMshSisuButtons($(".sign-in-out-link"));

import './lib/msh-sisu';
import './lib/msh-password-reset';
import './lib/msh-email-verification';
import './lib/msh-recent-favorites';
import './lib/msh-recent-viewed-pages';
import './lib/msh-favorites';
import './lib/msh-document-listing';
import './lib/msh-contact-listing';
import './lib/msh-notification-listing';
import './lib/msh-header';
import './lib/resaleowner-verification-form';
import './lib/msh-homeowner-resources';
import './lib/msh-contact-tab';
import './lib/msh-create-account';
import './lib/my-account-contact-info-owner';
import './lib/my-account-contact-info-shopper';
import './lib/msh-community-preference';
import './lib/msh-account-settings';
import iframeIosHelper from "./lib/iframe-ios-helper";
import { CalendarHelper } from './lib/calendar-helper';
window.CalendarHelper = CalendarHelper;

// Service Request
import './lib/request-service-ui';
import './lib/service-request-log-ui';

/**
 * @todo refactor this out of app.js and dynamic load into module html
 */
import './community-search';
import './blog-listing.js'
window.BlogListing = BlogListing;

import './news-event-listing.js'
window.NewsEventListing = NewsEventListing;

//****************************************************************************/
// Forms
//****************************************************************************/
import MoreInfoForm from './lib/forms/form-more-info';
window.MoreInfoForm = MoreInfoForm;

// Used for submitting kentico form widgets with community selector options.
// For example: interestlist form widget, schedulevisit form widget, etc...
import GeneralKenticoForm from './lib/forms/form-general-kentico.js';
window.GeneralKenticoForm = GeneralKenticoForm;

// Form object used with the GeneralInquiryFormWidget.
import GeneralInquiryForm from './lib/forms/form-general-inquiry.js';
window.GeneralInquiryForm = GeneralInquiryForm;

// Forms
import JoinTheMovementForm from './lib/forms/form-join-the-movement';
window.JoinTheMovementForm = JoinTheMovementForm;

// Form object used with the PriorityListForm Widget.
import PriorityListForm from './lib/forms/form-priority-list.js';
window.PriorityListForm = PriorityListForm;

// Warranty Request Public Form
import WarrantyRequestPublicForm from './lib/forms/form-warranty-request-public.js';
window.WarrantyRequestPublicForm = WarrantyRequestPublicForm;

import findAzureAuthAndProcess from './lib/azure-wcag';

//****************************************************************************/
// Activities
//****************************************************************************/
import ActivityHelper from './lib/activities/activity-helper.js';
window.ActivityHelper = ActivityHelper;

//****************************************************************************/
// Modules
//****************************************************************************/

// NOTE: SnazzyWindow is imported localy in functions below because it needs to be loaded once Google Maps API

/**
 * @deprecated moving to `CommunnitySearch` class in `community-search.js`
 */
// window.regionCommunitiesMapJson = [
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000001",
//         "Name": "Test Shea Community",
//         "Brand": "shea",
//         "Lat": 33.727629,
//         "Long": -117.811157,
//         "City": "Irvine",
//         "State": "CA",
//         "BedroomsMin": 1,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 1,
//         "BathrooomsMax": 2,
//         "PriceMinString": "$200,000",
//         "PriceMaxString": "$750,000",
//         "SquareFeetMin": 1250,
//         "SquareFeetMax": 3850,
//         "StoriesMin": 2,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 1", "Type 3"],
//         "Features": ["Feature 1", "Feature 2"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/o3rd34sojb/370x240px@1x/Trilogy_Summerlin_Plan_Explore_Elev_A.jpg?q=100"
//     },
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000001",
//         "Name": "Test Trilogy Community",
//         "Brand": "trilogy",
//         "Lat": 33.675609,
//         "Long": -117.605464,
//         "City": "Orange",
//         "State": "CA",
//         "BedroomsMin": 2,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 2.5,
//         "BathrooomsMax": 3.5,
//         "PriceMinString": "$550,000",
//         "PriceMaxString": "$850,000",
//         "SquareFeetMin": 200,
//         "SquareFeetMax": 4100,
//         "StoriesMin": 1,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 2", "Type 3"],
//         "Features": ["Feature 2"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/o3rd34sojb/370x240px@1x/Trilogy_Summerlin_Plan_Explore_Elev_A.jpg?q=100"
//     }
// ];

/**
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// window.fyhSearchMapJson = [
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000001",
//         "Name": "36th & Holt",
//         "Brand": "shea",
//         "Lat": 33.727629,
//         "Long": -117.811157,
//         "City": "Irvine",
//         "State": "CA",
//         "BedroomsMin": 1,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 1,
//         "BathrooomsMax": 2,
//         "PriceMinString": "$200,000",
//         "PriceMaxString": "$750,000",
//         "SquareFeetMin": 1250,
//         "SquareFeetMax": 3850,
//         "StoriesMin": 2,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 1", "Type 3"],
//         "Features": ["Feature 1", "Feature 2"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/o3rd34sojb/370x240px@1x/Trilogy_Summerlin_Plan_Explore_Elev_A.jpg?q=100"
//     },
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000002",
//         "Name": "Aperture at Gateway Quarter",
//         "Brand": "trilogy",
//         "Lat": 33.675609,
//         "Long": -117.605464,
//         "City": "Orange",
//         "State": "CA",
//         "BedroomsMin": 2,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 2.5,
//         "BathrooomsMax": 3.5,
//         "PriceMinString": "$550,000",
//         "PriceMaxString": "$850,000",
//         "SquareFeetMin": 200,
//         "SquareFeetMax": 4100,
//         "StoriesMin": 1,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 2", "Type 3"],
//         "Features": ["Feature 2"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/5ljc9ohqqc/584x376px/Ascent_4014_Kitch.jpeg?position=c&crop=true&color=ffffffff&u=e3tgab"
//     },
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000003",
//         "Name": "Ascent at Eastmark",
//         "Brand": "shea",
//         "Lat": 32.988593,
//         "Long": -117.181460,
//         "City": "San Diego",
//         "State": "CA",
//         "BedroomsMin": 1,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 1,
//         "BathrooomsMax": 2,
//         "PriceMinString": "$200,000",
//         "PriceMaxString": "$750,000",
//         "SquareFeetMin": 1250,
//         "SquareFeetMax": 3850,
//         "StoriesMin": 2,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 1", "Type 3"],
//         "Features": ["Feature 1", "Feature 2"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/9x8offadpz/584x376px/Balmoral_Plan4039_Kitchen.jpeg?position=c&crop=true&color=ffffffff&u=e3tgab"
//     },
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000004",
//         "Name": "Briar Square at Mountain House",
//         "Brand": "trilogy",
//         "Lat": 32.817912,
//         "Long": -116.773035,
//         "City": "Alpine",
//         "State": "CA",
//         "BedroomsMin": 2,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 2.5,
//         "BathrooomsMax": 3.5,
//         "PriceMinString": "$550,000",
//         "PriceMaxString": "$850,000",
//         "SquareFeetMin": 200,
//         "SquareFeetMax": 4100,
//         "StoriesMin": 1,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 2", "Type 3"],
//         "Features": ["Feature 2"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/t9dzw636js/584x376px/Harmony_Vivace_Plan_4132_Grt_Rm_E.jpeg?position=c&crop=true&color=ffffffff&u=e3tgab"
//     },
//     {
//         "NodeGUID": "00000000-1111-2222-3333-000000000005",
//         "Name": "Cane Island",
//         "Brand": "shea",
//         "Lat": 32.817912,
//         "Long": -116.773035,
//         "City": "Alpine",
//         "State": "CA",
//         "BedroomsMin": 2,
//         "BedroomsMax": 3,
//         "BathrooomsMin": 2.5,
//         "BathrooomsMax": 3.5,
//         "PriceMinString": "$750,000",
//         "PriceMaxString": "$950,000",
//         "SquareFeetMin": 700,
//         "SquareFeetMax": 4500,
//         "StoriesMin": 2,
//         "StoriesMax": 2,
//         "Url": "https://www.google.com",
//         "CommunityTypes": ["Type 2"],
//         "Features": ["Feature 3"],
//         "ImageUrl": "https://embed.widencdn.net/img/sheahomes/o3rd34sojb/370x240px@1x/Trilogy_Summerlin_Plan_Explore_Elev_A.jpg?q=100"
//     }
// ];

/* END GLOBAL VARIABLES */



/**
 * Wrapper to invoke the foundation() function from outside of this webpack bundle (e.g., in cms admin, window, etc.)
 * @param {jQuery Element} jqueryElem jQuery element on which to invoke foundation() on
 * @param {*} foundationFuncArgs x number of parameters suitable for using with foundation(). Look at Foundation documentation
 * for parameters and values supported here
 */
function foundationWrapper(jqueryElem, ...foundationFuncArgs){
    $(jqueryElem).foundation(...foundationFuncArgs);
}
window.foundationWrapper = foundationWrapper;
 
var lozadObserver = lozad('.lozad', {
    rootMargin: '250px 0px' // If the image gets within 50px in the Y axis, start the download.
});
// custom event to check if app.js is loaded


// Lozad lazy loads all images with .lozad class
function lozadObserve(){
    // use lozad object created in app.js
    lozadObserver.observe();
}

// First set of cards/imgs
lozadObserve();

// View More
window.lozadObserver = lozadObserve;
window.isSheaAppJsLoaded = false;

$(function () {

    window.appJsLoaded = new CustomEvent("appJsLoaded", {
        detail: {
          message: "application js loaded"
        }
      });

    // dispatch custom event to check if app.js is loaded
    window.dispatchEvent(window.appJsLoaded);
    window.isSheaAppJsLoaded = true;

    // set timeout duration for third party integrations atlasRTX and userway
    const USER_VISITED_SESSION_STORAGE_KEY = "userVisited";
    var userVisited = sessionStorage.getItem(USER_VISITED_SESSION_STORAGE_KEY);
    window.JS_LOAD_DELAY_DURATION = userVisited != null ? 1000 : 10000;
    if (userVisited == null) {
        sessionStorage.setItem(USER_VISITED_SESSION_STORAGE_KEY, "User Visited");
    }

    /**
     * Exexcute azure wcag functions
    */
    findAzureAuthAndProcess();

    // This is needed to move the foundation reveal modal within the ASP.NET form element
    if (IS_LOCALHOST === false) {
        $(document).on('open.zf.reveal', '.home-search-form-wrapper-mobile[data-reveal]', function () {
            $(this).appendTo($("#form"));
        });

        // Attempt to grab window.msh.marketingSiteUrl set by backend
        if (window.msh && window.msh.marketingSiteUrl){
            MARKETING_SITE_URL = window.msh.marketingSiteUrl;
        }
    }

    // Manually trigger lazy loaded images within reveal modals to prevent modal
    // skewin its placement
    $(".view-photos-btn").on("click", function () {
        var associatedModal = $("#" + $(this).data("open"));
        triggerLazyLoadRevealImages(associatedModal);
    });
   
    setTimeout(() => {
        //initialize shea video players
        initSheaVideoPlyr();
            
        //initialize reveal video players
        initRevealVideoPlyr();

        // Initialize Hide menu for tab controls
        initTabMobile();

        // Initialize and handle accessibility style switches
        initAccessibilityToggle();

        // Initialize the global header
        initDrilldownFunctions();

        // Initialize media uploader and truncation
        initMediaUploader();

        // let swiperMediaCarousels = document.querySelectorAll(".media-with-thumbnails-carousel");
        // if (swiperMediaCarousels && swiperMediaCarousels.length > 0) {
        //     swiperMediaCarousels.forEach(carousel => {
        //         initMediaWithThumbnailCarousel(carousel);
        //     });
        // }
        initMediaWithThumbnailCarousels(document);
        
        let swiperMediaCarouselsWithoutThumbs = document.querySelectorAll(".media-without-thumbnails-carousel");
        if (swiperMediaCarouselsWithoutThumbs && swiperMediaCarouselsWithoutThumbs.length > 0) {
            swiperMediaCarouselsWithoutThumbs.forEach(carousel => {
                initMediaCarousel(carousel);
            });
        }
        
    }, 0);

    setTimeout(() => {
        // Init the media-modal elements
        initMediaModals($(".media-modal"));

        // Init Video gallery active class
        initVideoSlider();

        // Init Image Showcase to size it properly
        initImageShowcase($(".image-showcase"));

        // Init accordion card carousel on accordion-title trigger click
        initAccordionCardCarousel();

        // Init the custom dropdowns that utilize Select2
        initCustomDropdowns();

        // Init the FYH Reusable Search Form (on clicks, etc.)
        initReusableSearchForm();
    }, 0);
    
    setTimeout(() => {
        //Init the Population of Dropdown filters for blog landing from Json.
        // DEPRECATED CALL
        //intiPopulateBlogLandingStatesDD();

        //Init to getBlogFilterData
        // DEPRECATED CALL
        //initGetBlogFiltersData();

        // Initi the Preloader found in the filters
        initPreLoader();

        // Init Selected area height check
        intSelectedAreaSize();

        // Init the filters on the News & Events LP
        // DEPRECATED CALL
        //initNewsEventsFilterForm();

        // Init the Favorite button functionality inside of highlight like button function
        highlightLikeButtons();

        initCheckMshDrilldown();

        // Community Lot Map
        // DEPRECATED CALL
        //initCommunityLopMapSVG();
        // Community Sitemap Webpart
        // DEPRECATED CALL
        //initCommunitySitemapWebpart();

        initPillboxButtons();

        // Render PDF Components (iframe and object pdfs)
        initPdfIframeRenderers();
        initPdfObjectRenderers();

        // full widthifies fallback images of PDFs in iframes
        iframeIosHelper("[data-pdf-iframe]");
    }, 0);
    
    let qmiTabDrilldown = $('#details a[data-qmi-tab-drilldown]'),
    qmiTimeout;

    //find a button element configured with a jump link to the QMI tab section
    qmiTabDrilldown.on('click', function() {
        qmiTimeout = setTimeout(clickQMITab, 500);
    });

    //force click the QMI tab to show the QMI listing content
    function clickQMITab() {
        let qmiTab = $('#qmi-display-tab a');

        if (qmiTab.length > 0) {
            qmiTab.trigger('click');
            clearTimeout(qmiTimeout);
        }
    }

    //Get url, convert within URL function and search URL for qmi-select parameter
    const readUrl = window.location.href;
    const url = new URL(readUrl);
    const params = new URLSearchParams(url.search);
    
    //If parameter is found in the URL, click qmi tab after short delay.
    if (params.has("qmi-tab-select") === true) {
        setTimeout(clickQMITab, 500);        
    } else {
        return
    }
        
});

/**
 * Global Header Code
 */

/**
 * Initializes the the specified drilldown.
 * @param elem - jQuery element pointing to element containing a .drilldown element
 */
function initDrilldownFunctions() {

    $("[data-close-dropdown]").on("click" , function() {
    $(".nested").removeClass('is-active');
    $(".nested").removeClass('visible');
    $(".nested").addClass('invisible');
    $("[data-dropdown]").foundation('close');
    });

}


/**
 * Global Footer Code
 */

/**
 * Initializes the toggle and setting of accessibility styles
 */
function initAccessibilityToggle() {
    // Check for the wcag cookie on the body element
    var isWcagEnabled = $("body").hasClass(BODY_WCAG_CLASS);
    if (isWcagEnabled === true) {
        enableAccessibilityStyles(true);
    }
    else {
        enableAccessibilityStyles(false);
    }

    // Set click handler for accessible style swtich
    $(".footer-accessible-toggle").click(function () {
        // Determine whether or not we need to turn accessible styling on or off now
        var turnOnAccessibilityStyles = !$(this).hasClass(ACCESSIBILITY_ENABLED);

        enableAccessibilityStyles(turnOnAccessibilityStyles);
    });
}


/*
 * Helper function to handle initializing image carousels that use captions
 * @param {bool} carouselElem jQuery element pointing to carousel
 */


//function to stop the iframe on the general modals
// $('.media-modal-close').on('click', function(){
//     $('.video-frame').find("iframe").each(function (index, elem) {
//         initWidenVideos(elem)
//     });
// })


function initMediaCarouselWithCaptions(carouselElem) {
    var carousel = $(carouselElem);

    carousel.each(function (index, value) {
        var carouselInstance = $(value);

        // Sync the carousel and captions
        carouselInstance
            .find("[data-orbit]")
            .on("slidechange.zf.orbit", function () {
                var slides = $(this).find(".orbit-slide");
                var numSlides = slides.length;
                var activeSlide = $(this).find(".orbit-slide.is-active");
                var activeNum = slides.index(activeSlide);
                console.log(slides);
                // Show the appropiate figure caption
                var captions = $(this).find(".media-caption");
                captions.removeClass("is-active");
                var activeCaption = $(
                    $(this).find(".media-caption")[activeNum]
                );
                activeCaption.addClass("is-active");


                var videos = document.querySelectorAll('iframe, video');
                Array.prototype.forEach.call(videos, function (video) {
                    if (video.tagName.toLowerCase() === 'video') {
                        video.pause();
                    } else {
                        var src = video.src;
                        video.src = src;
                    }
                });
            });
    });
}
/**
 * Initialize videoVideoSlider
 * Updates the orbit slider to play video on new slide and pause previous slide
 */
function initVideoSlider() {
    //only run on medium and up
    if (Foundation.MediaQuery.atLeast('medium')) {
        $('.orbit.video-gallery-slider').on('beforeslidechange.zf.orbit', function (event) {
            var video = $('.shea-video');
            $(video).each(function () {
                $(this).get(0).pause();
            });
        });
    };
}

/**
 * Helper function to handle enabling and disabling accessibility styling on the page
 * @param {bool} enableAccessibilityStyles true to enable styling, false to disable styling
 */
function enableAccessibilityStyles(enableAccessibilityStyles) {

    if (enableAccessibilityStyles === true) {
        // Set the session cookie to mark accessibility styling enabled
        Cookies.set(ACCESSIBILITY_COOKIE, '1');

        // Update the UI
        $("body").addClass(BODY_WCAG_CLASS);
        $(".footer-accessible-toggle").addClass(ACCESSIBILITY_ENABLED);
        $(".footer-accessible-toggle-value").text("Turn Off");
    }
    else {
        // Unset the session cookie to mark accessibility styling disabled
        Cookies.set(ACCESSIBILITY_COOKIE, '0');

        // Update the UI
        $("body").removeClass(BODY_WCAG_CLASS);
        $(".footer-accessible-toggle").removeClass(ACCESSIBILITY_ENABLED);
        $(".footer-accessible-toggle-value").text("Turn On");
    }
}

/**
 * Initializes media modals (e.g., .media-modal class)
 * @param jQueryObject Points to video modal instance (i.e., has class media-modal)
 */
function initMediaModals(videoModals) {
    // Add event listener to stop videos on outside clicks
    // Add event to auto play video upon opening video modal
    $(videoModals).on("closed.zf.reveal", function (elem) {
        // Attempt to get modal video
        var revealModal = $(elem.target);        
        var iframevideos = document.querySelectorAll('iframe, video');
        Array.prototype.forEach.call(iframevideos, function (iframevideo) {
            if (iframevideo.tagName.toLowerCase() === 'video') {
                iframevideo.pause();
            } else {
                var src = iframevideo.src;
                iframevideo.src = src;
            }
        });

        // Switch to first slide in carousel so subsequent openings go to first slide
        // Needed to avoid showing other videos while first video autoplays on modal open 
        var firstSlide = revealModal.find("[data-slide=0]");

        if ($(firstSlide).length) {
            revealModal.find(".orbit").foundation('changeSlide', true, firstSlide, 0);
        }
    });
}

window.initMediaModals = initMediaModals;

function removeCookies()
{
    // before serving the page
    Cookies.remove(ATTEMPTED_FAVORITE_TYPE_COOKIE);
    Cookies.remove(ATTEMPTED_FAVORITE_GUID_COOKIE);
}

/**
 * Initializes the image showcase component
 * @param {jQuery element} elem
 */
function initImageShowcase(elem) {
    // On DOM Ready and screen size change, update the size of the image
    // showcase
    $(document).ready(resizeImageShowcase(elem));
    $(window).resize(resizeImageShowcase(elem));
}

/**
 * Resizes the image showcase component to properly display
 * @param {jqueryElem} elem
 */
function resizeImageShowcase(elem) {
    var XXLARGE_BREAKPOINT = 1920;
    if (Foundation.MediaQuery.atLeast('medium') === true) {
        // Set image container on right to match height of
        // highlight
        var newHeight = elem.find(".showcase-highlight").outerHeight();
        elem.find(".showcase-container-right").outerHeight(newHeight);
    }

    if ($(window).width() > XXLARGE_BREAKPOINT) {
        var newHeight = elem.find(".showcase-container").outerHeight() / 2;
        elem.find(".showcase-container-right").outerHeight(newHeight);
    }
}

// accordion card carousel slick slider
function initAccordionCardCarousel() {
    // count number of accordion titles
    $(".accordion-title").each(function (index) {
        var accordionCardCarouselSettings = {
            arrows: true,
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: "<div class='slick-arrow-prev'></div>",
            nextArrow: "<div class='slick-arrow-next'></div>",
            appendArrows: $('#arrow-wrapper-' + index),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
        // target each carousel child with ID
        $(this).click(function () {
            // initialize carousel
            $('#accordion-card-carousel-' + index).slick(accordionCardCarouselSettings);
            $('.slick-list').addClass('grid-container full');
            $('.slick-track').addClass('grid-padding-x');
        });
        // initialize card carousel on keydown | 13 == enter && 32 == spacebar
        $(this).keydown(function (e) {
            if (e.which == 13 || e.which == 32) {
                e.preventDefault();
                // initialize carousel
                $('#accordion-card-carousel-' + index).slick(accordionCardCarouselSettings);
                $('.slick-list').addClass('grid-container full');
                $('.slick-track').addClass('grid-padding-x');
            }
        });
    });
}

// initialized accordion carousel arrow wrapper
// the .large-accordion-arrow-wrapper sets a dyanmic height based on
// the card image so the carousel arrows are always at 50% of the
// height of the image at any breakpoint
function initArrowWrapper() {
    $(".accordion-title").each(function (index) {
        $('#accordion-card-carousel-' + index).on('init', function (event, slick) {
            var imageHeight = $(this).find('.card-image-height').innerHeight() / 2.0;
            $('#arrow-wrapper-' + index).css({ 'height': imageHeight });
        });
    });
}



// Target Small Breakpoint for global tabs
function initTabMobile(){
    $('.global-tabs-title').on('click', function () {
        if (Foundation.MediaQuery.is('small only')) {
            $('.global-tabs').toggleClass('open');
        }
    });
}


/**
* Initializes shea-custom-dropdown-multiselect and shea-custom-dropdown-singleselect
* elements that use Select2 dropdown library
*
* @param {String|jQuery element} elem Dropdown element which needs to be initialized
* @param {bool} isMultiSelect If set to true, initialize elem as multi select dropdown. Else, initialize as single select.
* @param {bool} animate Serves as override to animate or not animate the dropdown into view
*/
function initCustomDropdowns(elem, isMultiSelect, animate) {
    // Init the dropdown array to be empty
    var singleSelectDropdowns = [];
    var multiSelectDropdowns = [];

    // Check to see if we are initializing a specific element only.
    if ($(elem).length > 0) {
        if (isMultiSelect === true) {
            multiSelectDropdowns = $(elem);
        }
        else {
            singleSelectDropdowns = $(elem);
        }
    }
    else {
        // do NOT include region search filteres to avoid initializing them twice as ther are loaded within community-search-filters.js
        singleSelectDropdowns = $(".shea-custom-dropdown-singleselect:not(.home-search-form-dropdown)");
        multiSelectDropdowns = $(".shea-custom-dropdown-multiselect:not(.home-search-form-dropdown)");
    }

    $.when(
        initSelect2Dropdowns(singleSelectDropdowns, multiSelectDropdowns)
    ).done(function(){
        /**
         * Special use case: Hide the HTML SELECT dropdown to prevent flickering on load and give select2 elements 0 opacity (they
         * will animate to full opacity once the library completes the rendering)
         */
        if( animate === false ) {
            // Do not want to fade...want full opacity immediately
            $('.home-search-form .select2-container').fadeTo(0.0, 1.0);
        }
        else if( $(".home-search-form").length > 0) {
            $('.home-search-form .select2-container').fadeTo(1500, 1.0);
        }
    });

}

window.initCustomDropdowns = initCustomDropdowns;

/**
 * Intended to be used as a helper function for initCustomdDropdowns()
 * @param {*} singleSelectDropdowns
 * @param {*} multiSelectDropdowns
 */
function  initSelect2Dropdowns(singleSelectDropdowns, multiSelectDropdowns) {

    /**
     * Set up the Multi-Select Style Dropdowns
     */
    if (multiSelectDropdowns.length > 0) {
        multiSelectDropdowns.each(function (index, elem) {
            // Determine which classes from SELECT element we need to add to the Select2 container
            var cssClassesToAppend = "";
            if ( $(this).hasClass("grey-dropdown") ){
                cssClassesToAppend += " grey-dropdown";
            }
            if( $(this).hasClass("hide-selected-option") ) {
                cssClassesToAppend += " hide-selected-option";
            }
            if( $(this).hasClass("full-width-options") ) {
                cssClassesToAppend += " full-width-options";
            }
            if( $(this).hasClass("full-width-options-w-shadow") ) {
                cssClassesToAppend += " full-width-options-w-shadow";
            }

            $(this).select2({
                minimumResultsForSearch: Infinity,  // removes the search bar
                multiple: true,                      // allow multiple options to be selected
                closeOnSelect: false,
                allowClear: true,
                containerCssClass: "shea-custom-dropdown-container" + cssClassesToAppend,
                dropdownCssClass: "shea-custom-dropdown-results-container" + cssClassesToAppend,
                templateResult: function (elem) {
                    return $("<div class='shea-custom-dropdown-option' role='checkbox' tabindex='0' aria-checked='false'>" + elem.text + "</div>");
                }
            });
        });
        multiSelectDropdowns.each(function (index, elem) {
            // Forces selector to show Placeholder...See: https://select2.org/programmatic-control/add-select-clear-items#clearing-selections
            var dropdown = $(this);

            // Set the placholder text
            dropdown.val(null).trigger('change.select2');

            // Try to set the placeholder element
            var select2Container = dropdown.next(".select2");
            var placeholder = $(this).attr("placeholder");
            select2Container.find(".shea-custom-dropdown-container").removeAttr("role");    // remove combox role
            select2Container.find(".select2-selection__rendered").empty();
            select2Container.find(".select2-selection__rendered").append("<li class='dropdown-label' role='option'>" + placeholder + "</li>");
            // Set the aria attributes and role to match the selection__rendered as in the single select dropdown text
            select2Container.find(".select2-selection__rendered").attr("role", "listbox");

            // Flag to mark whether we should make this tab-able
            var notTabable = $(this).prop('disabled') ? true : false;
            select2Container.find(".select2-selection").attr("tabindex", "-1"); // dont want this ever tab-able
            if ( notTabable) {

                select2Container.find(".select2-selection__rendered").attr("tabindex", "-1");
            }
            else {
                select2Container.find(".select2-selection__rendered").attr("tabindex", "0");
            }


            // Format the displayed value when an item is selected or unselected
            // See: https://select2.org/programmatic-control/events
            dropdown.on("select2:select select2:unselect", function (e) {
                const TARGET_OPTION_ID = e.params.data._resultId;
                const TARGET_OPTION = $(`[id="${TARGET_OPTION_ID}"] > .shea-custom-dropdown-option`);
                var numSelected = dropdown.select2('data').length;
                var select2Container = dropdown.next(".select2");
                select2Container.find(".shea-custom-dropdown-container").removeAttr("role"); // remove combox role
                select2Container.find(".select2-selection__rendered").empty();
                select2Container.find(".select2-selection__rendered").attr("role", "listbox");

                // Toggle aria attributes for checkboxes
                if (TARGET_OPTION) {
                    TARGET_OPTION.attr("aria-checked") === "false" 
                        ? TARGET_OPTION.attr("aria-checked", "true")
                        : TARGET_OPTION.attr("aria-checked", "false");
                }

                if (numSelected == 1) {
                    // If there is only one item selected, then display it's text.
                    select2Container.find(".select2-selection__rendered").append("<li class='dropdown-label' role='option'>" + dropdown.find("option:selected").text() + "</li>");
                }
                else {
                    // If there are more than one item selected, then display the number of item selected
                    select2Container.find(".select2-selection__rendered").append("<li class='dropdown-label' role='option'>" + dropdown.attr("placeholder") + " (" + numSelected + ")</li>");
                }

            });

            dropdown.on("change.select2", function (e) {
                var numSelected = dropdown.select2('data').length;
                var select2Container = dropdown.next(".select2");
                select2Container.find(".shea-custom-dropdown-container").removeAttr("role");    // remove combox role
                select2Container.find(".select2-selection__rendered").empty();
                select2Container.find(".select2-selection__rendered").attr("role", "listbox");
                if (numSelected == 1) {
                    // If there is only one item selected, then display it's text.
                    select2Container.find(".select2-selection__rendered").append("<li class='dropdown-label' role='option'>" + dropdown.find("option:selected").text() + "</li>");
                } else {
                    // If there are more than one item selected, then display the number of item selected
                    select2Container.find(".select2-selection__rendered").append("<li class='dropdown-label'>" + dropdown.attr("placeholder") + " (" + numSelected + ")</li>");
                }

            });

            // Need to latch onto open event to recheck the dropdown inputs because they are not set by Select2
            dropdown.on("select2:open", function (e) {
                // Loop through each checkbox in the select2 popup and check if aria signals it should be checked
                const OPTIONS_TO_CHECK = $(".select2-results__option[aria-selected='true'] div[role='checkbox']");
                OPTIONS_TO_CHECK.attr("aria-checked", "true");
            })

            // Program focus to return to the corresponding 'ul' dropdown element on close
            dropdown.on("select2:close", function(e) {
                const ACTIVE_EL = document.activeElement;
                $(ACTIVE_EL).find("ul:first").trigger("focus");
            })
        });
    }

    /**
     * Set up the Single-Select Style Dropdowns
     */
    if (singleSelectDropdowns.length > 0) {
        singleSelectDropdowns.each(function (index, elem) {
            // Determine which classes from SELECT element we need to add to the Select2 container
            var cssClassesToAppend = "";
            if ( $(this).hasClass("grey-dropdown") ){
                cssClassesToAppend += " grey-dropdown";
            }
            if( $(this).hasClass("hide-selected-option") ) {
                cssClassesToAppend += " hide-selected-option";
            }
            if( $(this).hasClass("full-width-options") ) {
                cssClassesToAppend += " full-width-options";
            }
            if( $(this).hasClass("full-width-options-w-shadow") ) {
                cssClassesToAppend += " full-width-options-w-shadow";
            }

            $(this).select2({
                minimumResultsForSearch: Infinity,
                multiple: false,
                closeOnSelect: true,
                allowClear: false,
                containerCssClass: "shea-custom-dropdown-container" + cssClassesToAppend,
                dropdownCssClass: "shea-custom-dropdown-results-container" + cssClassesToAppend,
                placeholder: $(this).attr("placeholder"),
                templateResult: function (elem) {
                    return $("<div class='shea-custom-dropdown-option'>" + elem.text + "</div>");
                }
            });

        });
        singleSelectDropdowns.each(function (index, elem) {
            var dropdown = $(this);

            // Try to set the placeholder element if no default option is selected. If no option is specified, display the placeholder
            var defaultSelection = $(dropdown.find("option:selected"));
            if (defaultSelection.length > 0) {
                var select2Container = dropdown.next(".select2");
                var placeholder = $(this).attr("placeholder");
                select2Container.find(".select2-selection__rendered").empty();
                select2Container.find(".select2-selection__rendered").append("<span class='dropdown-label'>" + defaultSelection.text() + "</span>");
            }
            else {
                var select2Container = dropdown.next(".select2");
                var placeholder = $(this).attr("placeholder");
                select2Container.find(".select2-selection__rendered").empty();
                select2Container.find(".select2-selection__rendered").append("<span class='dropdown-label'>" + placeholder + "</span>");
            }

            // See: https://select2.org/programmatic-control/events
            dropdown.on("select2:select select2:unselect", function (e) {
                //var data = e.params.data;
                var data = dropdown.find("option:selected").text();
                var select2Container = dropdown.next(".select2");

                select2Container.find(".select2-selection__rendered").empty();
                select2Container.find(".select2-selection__rendered").append("<span class='dropdown-label'>" + data + "</span>");
            });

            dropdown.on("change.select2", function (e) {
                var select2Container = dropdown.next(".select2");
                var placeholder = dropdown.attr("placeholder");
                select2Container.find(".select2-selection__rendered").empty();
                select2Container.find(".select2-selection__rendered").append("<span class='dropdown-label'>" + placeholder + "</span>");
            });
        });
    }
}

/**
 * Initializes the FYH Reusable Search form
 */
function initReusableSearchForm() {
    // Set up the apply filter click listener for FYH Reusable Search forms
    var redirectUrl = "/new-homes";
    if(MARKETING_SITE_URL) {
        redirectUrl = MARKETING_SITE_URL + redirectUrl;
    }

    $(".fyh-reusable-search .fyh-search-apply-filters").click(function (e) {
        e.preventDefault();

        if (IS_LOCALHOST == true) {
            redirectUrl = "index.html";
        }
        // serialize the form data to pass to redirect page
        // plus symbol is removed from the url parameter values
        var formData = $("#reusable-search select, #reusable-search input")
            .serialize()
            .split('&')
            .map(function(param) {
                var parts = param.split('=');
                return parts[0] + '=' + decodeURIComponent(parts[1]).replace(/\+$/g, '');
            })
            .join('&');
        location.href = redirectUrl + "?" + formData;
    });

    /**
     * Handle Price Min selection by hiding
     */

    var priceMinDropdowns = $("select[name=pricemin]");
    var priceMaxDropdowns = $("select[name=pricemax]");
    priceMinDropdowns.on("select2:select select2:unselect", function (e) {
        // Get current price min and max values
        var priceMinCurrentValue = priceMinDropdowns.find("option:selected").val();
        var priceMaxCurrentValue = priceMaxDropdowns.find("option:selected").val();

        // Get all options in price max dropdown that preceed the selected value and hide them
        var priceMaxOptions = $(priceMaxDropdowns.find("option"));

        // Get references to options for enabling/disabling later
        var priceMaxCorrespondingOption = $(priceMaxDropdowns.find("option[value=" + priceMinCurrentValue +"]"));
        var priceMaxOptionsToDisable = $(priceMaxCorrespondingOption).prevAll();
        var priceMaxAnyOption = $(priceMaxDropdowns.find("option[value=any]"));

        // Enable all options and then selectively disable options
        priceMaxOptions.prop("disabled", false);
        if ( priceMinCurrentValue !== "any" ) {
            $(priceMaxCorrespondingOption).prop("disabled", true);
            $(priceMaxOptionsToDisable).prop("disabled", true);
            $(priceMaxAnyOption).prop("disabled", false);
        }

        // Reinit the dropdown without animation
        initCustomDropdowns(priceMaxDropdowns, false, false);

        // If the user selected a price max less than this min selection, reset price max to be any
        if ( parseInt(priceMaxCurrentValue) <= parseInt(priceMinCurrentValue) ) {
            priceMaxDropdowns.val("any").trigger("select2:select");
        }
    });

    priceMaxDropdowns.on("select2:select select2:unselect", function (e) {
        // Get current price min and max values
        var priceMinCurrentValue = priceMinDropdowns.find("option:selected").val();
        var priceMaxCurrentValue = priceMaxDropdowns.find("option:selected").val();


        // Get all options in price max dropdown that preceed the selected value and hide them
        var priceMinOptions = $(priceMinDropdowns.find("option"));

        // Get references to options for enabling/disabling later
        var priceMinCorrespondingOption = $(priceMinDropdowns.find("option[value=" + priceMaxCurrentValue +"]"));
        var priceMinOptionsToDisable = $(priceMinCorrespondingOption).nextAll();
        var priceMinAnyOption = $(priceMinDropdowns.find("option[value=any]"));

        // Enable all options and then selectively disable options
        priceMinOptions.prop("disabled", false);
        if ( priceMaxCurrentValue !== "any" ) {
            $(priceMinCorrespondingOption).prop("disabled", true);
            $(priceMinOptionsToDisable).prop("disabled", true);
            $(priceMinAnyOption).prop("disabled", false);
        }

        // Reinit the dropdown without animation
        initCustomDropdowns(priceMinDropdowns, false, false);

        // If the user selected a price max less than this min selection, reset price max to be any
        if ( priceMinCurrentValue >= priceMaxCurrentValue ) {
            //priceMinDropdowns.val("any").trigger("select2:select");
        }
    });
}

/**
 * Initializes the MediaUploader Clear
 */
function initMediaUploader() {
    //Loop through the upload media inputs
    var fancyFileInput = document.querySelectorAll('.upload-file');
    Array.prototype.forEach.call(fancyFileInput, function (document) {
        var input = document.getElementsByClassName('upload-input')[0];
        var button = document.getElementsByClassName('upload-label')[0];
        //set class to show new styles
        document.className += ' is-active';
        input.onchange = function () {
            if (this.value) {
                button.innerHTML = this.value.replace(/^.*\\/, '');
                document.className += ' is-uploaded';
                var b = button.innerHTML; //create varible for truncation
                $(this).siblings('span').text(truncate(b, 10)); //limit character count to 10
            }
        };
        // Screen readers can access the input directly so ignore the presentational button.
        button.setAttribute('aria-hidden', 'true');
        button.onclick = function () {
            input.click();
        };

    });
    //delete button, clears the value of hidden input and replace text
    $(".file-uploader-remove").click(function (e) {
        e.preventDefault();
        $(this).siblings('span').text("Choose File"); //change the text of file name back
        $(this).siblings('input').val("");//clear value on the actual button
        $(this).closest('div').removeClass("is-uploaded"); //hides button
        $(this).closest('div').removeClass("is-invalid-input"); //affects border red color
    });
}
/**
 * Truncate extensions
 * Used to truncate extensions for input file, check msh service request
 */
function truncate(n, len) {
    var ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
    var filename = n.replace('.' + ext, '');
    if (filename.length <= len) {
        return n;
    }
    filename = filename.substr(0, len) + (n.length > len ? '[...]' : '');
    return filename + '.' + ext;
};

/**
 * Global Callback referenced in Google Maps CDN scrip tag
 * 
 * @deprecated use specific module js such as `find-your-home.js` and `event-map.js` for init functionality
 */
// window.initMaps = function () {
//     // Add map specific init functions here to be executed when Google Maps loads
//     initEventDetailsMap();
// }

/**
 * Initiazes the specified pricing tooltips or initializes all pricing toolips if none specified
 * @param {jQueryElement} elem Pricing Tooltip to initialize. Set to null to initialize all tooltips on page
 */
function initPricingTooltips(elem) {
    
    var tooltips = $(elem);
    
    // Determine if we need to target all pricing tooltips
    if( elem == null ) {
        const DEFAULT_PRICING_TOOLTIP_SELECTOR = "[data-tooltip].tooltip-price";
        tooltips = $(DEFAULT_PRICING_TOOLTIP_SELECTOR);
    }
    
    tooltips.foundation();
}
window.initPricingTooltips = initPricingTooltips;

/**
 * bindPricingTooltips
*/
function bindPricingTooltips(delay) {
    if (!delay) delay = 2000;
    setTimeout(function () {
        initPricingTooltips($("[data-tooltip].tooltip-price"))
    }, delay);
}

/**
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * @param {*} onlyUpdateData
 * 
 */
// function initFYHSearchResultsMapAndData(onlyUpdateData = false) {
//     // Require Snazzy Maps now that Google Maps has loaded
//     let SnazzyInfoWindow = require('./vendors/snazzy-info-window');

//     // Set the global map reference
//     var mapElement = document.getElementById('fyh-search-map');
//     if (mapElement == null) {
//         return;
//     }

//     // By page load, the backend should have populated the hidden field with map data
//     // Store in hidden field then force refresh
//     if (IS_LOCALHOST === false) {
//         var jsonData = JSON.parse($("#hiddenHomeSearchFormData").val());

//         if (jsonData) {
//             window.fyhSearchMapJson = jsonData;
//         }
//     }

//     // Update the num results label which is based on the number of currently visible items
//     if (fyhSearchMapJson != null) {
//         // Update the number of results based on the number of DOM elements (which indicates total number of query results)
//         fyhUpdateDisplayCount();
//     }
//     else {
//         $(".home-search-form-num-results, .search-results-cards-num-results, .search-results-cards-num-results-v2").text("0 Community Results");
//     }


//     // Icon map for communities
//     var host = "//" + window.location.host;
//     var iconBase = host + "/patternlibrary/dist/assets/img/maps/";
//     if (IS_LOCALHOST === true) {
//         iconBase = host + "/assets/img/maps/";
//     }
//     var communityIcons = {
//         shea: {
//             url: iconBase + 'single-community-pin-green-2x.png',
//             scaledSize: new google.maps.Size(28, 28), // scaled size
//         },
//         trilogy: {
//             url: iconBase + 'single-community-pin-green-2x.png',
//             scaledSize: new google.maps.Size(28, 28), // scaled size
//         }
//     };

//     // Clear markers and info windows from map if any and reset array and reset any active
//     // markers/labels
//     MapHelper.clearMarkers(MapHelper.fyhSearchMapMarkers);
//     MapHelper.fyhSearchMapMarkers = [];
//     MapHelper.fyhClearInfoWindows();

//     // Build list of community names as ordered by the server (look at the DOM order)
//     MapHelper.fyhSearchCommunityNodeGuidsSorted = [];
//     $(".search-results_wrapper-cell .card-community").each(function(){
//         MapHelper.fyhSearchCommunityNodeGuidsSorted.push($(this).text());
//     });

//     // Force sort dropdown to be at the default Alpha (a-z) sort option
//     var sortDropdown = $(".find-your-home #sort-dropdown");;
//     sortDropdown.prop('selectedIndex', 0);

//     // This will be used to incrementally extend the bounds of the map
//     // give each markers location to make sure map includes all markers
//     var bounds = new google.maps.LatLngBounds();

//     // For each region (should only be one for this map), loop through each community and
//     // display markers for each community in the region. Also, continue to adjust maps bounds
//     // to cover all markers
//     fyhSearchMapJson.forEach(function (community) {
//         var communityName = community["Name"];
//         var communityPosition = new google.maps.LatLng(community["Lat"], community["Long"]);
//         var communityPrice = community["PriceMinString"];
//         var communityUrl = community["Url"];
//         var communityTypes = community["CommunityTypes"];

//         var communityCity = community["City"];
//         var communityState = community["State"];

//         var communityBedMin = community["BedroomsMin"];
//         var communityBedMax = community["BedroomsMax"];

//         var communityBathMin = community["BathroomsMin"];
//         var communityBathMax = community["BathroomsMax"];

//         var communityNodeGuid = community["NodeGUID"];
//         var communityImageUrl = community["ImageUrl"];

//         // build icon path with guid parameter to facilitate icon look up later in code
//         var communityIcon = (community.brand == "trilogy" ? communityIcons["trilogy"] : communityIcons["shea"]);
//         communityIcon.url += `?guid=${communityNodeGuid}`;

//         // Create the marker (and give each marker a customInfo object)
//         var marker = new google.maps.Marker({
//             position: communityPosition,
//             icon: communityIcon,
//             map: MapHelper.fyhSearchMap,
//             customInfo: {
//                 name: communityName,
//                 position: communityPosition,
//                 price: communityPrice,
//                 url: communityUrl,
//                 communityTypes: communityTypes,
//                 city : communityCity,
//                 state : communityState,
//                 bedmin : communityBedMin,
//                 bedmax : communityBedMax,
//                 bathmin : communityBathMin,
//                 bathmax : communityBathMax,
//                 nodeGuid: communityNodeGuid,
//                 imageUrl: communityImageUrl
//             }
//         });

//         // Adjust the bounds
//         bounds.extend(marker.getPosition());

//         // Create InfoWindow popup on click event for mobile or mouseover for desktop
//         var eventName = 'click';
//         if (Foundation.MediaQuery.atLeast('xlarge')) {
//             eventName = "mouseover";
//         }

//         // Add event listener to open marker info window
//         google.maps.event.addListener(marker, eventName, function (evt) {
//             var guid = marker.customInfo.nodeGuid;
//             var infoWin = MapHelper.fyhSearchMapInfoWindows[guid];
//             MapHelper.fyhClearInfoWindows(false);
//             if( infoWin ) {
//                 MapHelper.fyhSetActiveMarker(guid);

//                 infoWin.open();
//                 MapHelper.fyhSearchMapActiveInfoWindow = infoWin;
//             }

//         });

//         // Reset active marker on marker mouse out
//         google.maps.event.addListener(marker, "mouseout", function (evt) {
//             MapHelper.fyhSetActiveMarker(null);
//         });

//         // Add the markers and adjust the maps bound with padding 
//         // on the top and bottom of the map to minimize change that
//         // markers appear at the very bottom of the map under the fold
//         MapHelper.fyhSearchMapMarkers.push(marker);
//         MapHelper.fyhSearchMap.fitBounds(bounds, {
//             top: 80,
//             bottom: 80
//         });
//     });

//     // Create clustering
//     // Add a marker clusterer to manage the markers.
//     // See Google Maps Clusterer SIcon Style docs here:
//     var clusterStyles = [
//         {
//             url: iconBase + "clusters/multi-community-pin-green-2x.png",
//             width: 28,
//             height: 28
//         }
//     ];
//     var markerClusterOptions = {
//         clusterClass: "fyh-cluster",
//         styles: clusterStyles,
//         gridSize: MapHelper.FYH_SEARCH_CLUSTER_GRID_SIZE
//     }

//     // Create cluster if initializing map for first time. Afterwards just clear markers and add new ones
//     // to ensure cluster only shows the latest communites from the MapHelper.fyhSearchMapMarkers array
//     if (MapHelper.fyhSearchMapClusterer == null) {
//         MapHelper.fyhSearchMapClusterer = new MarkerClusterer(MapHelper.fyhSearchMap, MapHelper.fyhSearchMapMarkers, markerClusterOptions);

//         // Now that the clustering has finished (it will udpate on redraw events such as pan and zoom),
//         // reset the side results section
//         google.maps.event.addListener(MapHelper.fyhSearchMapClusterer, 'clusteringend', function () {
//             fyhSearchResultsReset();
//             MapHelper.fyhSetActiveMarker(null);

//             // Create the label for the cluster
//             MapHelper.fyhCreateIconLabels(MapHelper.fyhSearchMap, MapHelper.fyhSearchMapMarkers, MapHelper.fyhSearchMapClusterer);

//             // set attributes needed for feaures such as styling active clusters
//             MapHelper.setClusterIconAttributes(MapHelper.fyhSearchMapClusterer);

//             // create windows for all markers and clusters now that clustering algorithm has finished
//             MapHelper.fyhCreateInfoWindows();

//             // Determine whether or not to scroll the user back to the 
//             // top of the page based on whether the center or zoom has shifted
//             var curCenter = MapHelper.fyhSearchMap.getCenter();
//             var curZoom = MapHelper.fyhSearchMap.getZoom();
//             var prevCenter = MapHelper.fyhSearchMapLastCenter;
//             var prevZoom = MapHelper.fyhSearchMapLastZoom;

//             // Show preloader when the map moves and triggers this event (NOTE: loader also
//             // displays as result of recenter button click and other events such as apply filters
//             // click)
//             showPreLoader($(".find-your-home"));

//             // If the current zoom or center has shifted from the original set,
//             // scroll the user back to the top of the screen since the listings may change
//             // and we dont want to be out of position when new data is loaded into the listing
//             const RECENTER_LOADER_DURATION = 200;
//             if( curZoom !== prevZoom
//                 || curCenter.lat() !== prevCenter.lat()
//                 || curCenter.lng() !== prevCenter.lng()) {
//                 // because community listing updates based on map, make sure to scroll to top of
//                 // the page on tablet and above to prevent bad UX of user being placed at footer when map changes the 
//                 // height of the listing
//                 if (Foundation.MediaQuery.atLeast('medium')) {
//                     $('html, body').animate({
//                         scrollTop: $('header').offset().top
//                     }, RECENTER_LOADER_DURATION);
//                 }
//             }

//             // hide the preloader from the map that may have been raised from 
//             // the clicking of the recenter button
//             // need to wait for the scroll to complete before allowing user to interact with the page
//             setTimeout(function(){
//                 hidePreLoader($(".find-your-home"));

//                 // For some unknown reason, after we scroll to 
//                 // top of page, the sticky container does NOT set .is-at-top class correctly
//                 // and instead the map sticky container is .is-at-bottom...fix this manually 
//                 // and set its top to 0
//                 $("#fyh-search-sticky").removeClass("is-at-bottom");
//                 $("#fyh-search-sticky").addClass("is-at-top");
//                 $('#fyh-search-sticky').css({top: 0});
//             }, RECENTER_LOADER_DURATION);

//             // Update lat/lng and zoom tracker to restore map state on mobile map tab click
//             MapHelper.fyhSaveLastMapCenterAndZoom(MapHelper.fyhSearchMap.getCenter(), MapHelper.fyhSearchMap.getZoom());

//             bindPricingTooltips();
//         });

//         // handle the mouseover state and change icon to the active/hover state icon 
//         google.maps.event.addListener(MapHelper.fyhSearchMapClusterer, "mouseover", function (cluster) {
//             // get first marker in this cluster and use its guid
//             var marker = cluster.markers_[0];
//             var guid = marker.customInfo.nodeGuid;
//             MapHelper.fyhSetActiveMarker(guid);
//         });

//         // handle the mouseout state and change back to the default icon
//         google.maps.event.addListener(MapHelper.fyhSearchMapClusterer, "mouseout", function (cluster) {
//             MapHelper.fyhSetActiveMarker(null);
//         });
//     }
//     else {
//         MapHelper.updateMarkerClusterMarkers(MapHelper.fyhSearchMapClusterer, MapHelper.fyhSearchMapMarkers);
//         MapHelper.fyhSearchMapClusterer.setGridSize(MapHelper.FYH_SEARCH_CLUSTER_GRID_SIZE);
//         MapHelper.setClusterIconAttributes(MapHelper.fyhSearchMapClusterer);
//         MapHelper.fyhSearchMapClusterer.repaint();
//     }

//     // If there are zero results, then center the map on Chicago (approximate center of USA) and set it to max zoom
//     if( fyhSearchMapJson == null || fyhSearchMapJson.length < 1 ) {
//         // Define default center and zoom to use
//         var center = new google.maps.LatLng(MapHelper.FYH_SEARCH_COMMUNITIES_DEFAULT_INITIAL_CENTER_LAT, MapHelper.FYH_SEARCH_COMMUNITIES_DEFAULT_INITIAL_CENTER_LLONG) // Lat and Long of Chicago
//         var zoom = MapHelper.FYH_SEARCH_COMMUNITIES_DEFAULT_INITIAL_ZOOM;

//         // Set the center and zoom for the map and record it for use later
//         MapHelper.fyhSearchMap.setCenter(center);
//         MapHelper.fyhSearchMap.setZoom(zoom);
//         MapHelper.fyhSetMapCenterAndZoom(center, zoom);
//     }
//     // Create Legend only if this is the first initialization (ie.g., not updating markers)
//     if (onlyUpdateData === false) {
//         var legend = document.getElementById("fyh-search-legend");
//         if (legend != null) {
//             MapHelper.fyhSearchMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
//         }
//     }

//     // Set zoom depending on markers
//     // Event signals map is finished loading so record the zoom level
//     // calculated by the initial set of fitBounds() invocations based on all markers
//     var fyhSearchMapIdleListener = google.maps.event.addListenerOnce(MapHelper.fyhSearchMap, 'idle', function () {
//         // Map is now idle after creating first round of markers, grab the zoom level, record
//         // it, and set the map's min zoom (zooming out further equates to smaller zoom level number)
//         MapHelper.fyhSearchMapZoom = MapHelper.fyhSearchMap.getZoom();
//         MapHelper.fyhSearchMap.setOptions({
//             maxZoom: MapHelper.FYH_SEARCH_COMMUNITIES_MAX_ZOOM
//         });
//         MapHelper.fyhSearchMap.setZoom(MapHelper.fyhSearchMapZoom);

//         if (MapHelper.fyhSearchMapClusterer != null) {
//             MapHelper.fyhSearchMapClusterer.setGridSize(MapHelper.FYH_SEARCH_CLUSTER_GRID_SIZE);
//             MapHelper.setClusterIconAttributes(MapHelper.fyhSearchMapClusterer);
//             MapHelper.fyhSearchMapClusterer.repaint();
//         }

//         // record the fyh map center and zoom so we can later reset and zoom to this setting on Recenter Button click
//         var centerAfterIdle = MapHelper.fyhSearchMap.getCenter();
//         var zoomAfterIdle = MapHelper.fyhSearchMap.getZoom();
//         MapHelper.fyhSetMapCenterAndZoom(centerAfterIdle, zoomAfterIdle);

//         // Update lat/lng and zoom tracker to restore map state on mobile map tab click
//         MapHelper.fyhSaveLastMapCenterAndZoom(MapHelper.fyhSearchMap.getCenter(), MapHelper.fyhSearchMap.getZoom());
//     });

//     if ( MapHelper.fyhSearchMapClusterHoverListener != null ) {
//         google.maps.event.removeListener(MapHelper.fyhSearchMapClusterHoverListener);
//     }
//     // Create InfoWindow popup on click event for mobile or mouseover for desktop
//     var clusterEventName = 'click';
//     if (Foundation.MediaQuery.atLeast('xlarge')) {
//         clusterEventName = "mouseover";
//     }
//     MapHelper.fyhSearchMapClusterHoverListener = google.maps.event.addListener(MapHelper.fyhSearchMapClusterer, clusterEventName, function (cluster) {
//         // Only proceed with popup logic if we are at the max zoom for this map
//         var currentZoom = MapHelper.fyhSearchMap.getZoom();
//         if (currentZoom == MapHelper.FYH_SEARCH_COMMUNITIES_MAX_ZOOM) {

//             // find the marker that has the guid of interest
//             var allClusterMarkerGuids = "";

//             var markers = cluster.getMarkers();
//             markers.forEach(function (marker, index) {
//                 var markerGuid = marker.customInfo.nodeGuid;

//                 // Compile "|" delimited list of guids this cluster represents
//                 allClusterMarkerGuids += markerGuid;
//                 if (index < markers.length - 1) {
//                     allClusterMarkerGuids += "|";
//                 }
//             });

//             var infoWin = MapHelper.fyhSearchMapInfoWindows[allClusterMarkerGuids];
//             if (infoWin) {
//                 infoWin.open();
//                 MapHelper.fyhSearchMapActiveInfoWindow = infoWin;
//             }
//         }
//     });

//     // now that data has been updates, reset any active markers/labels
//     MapHelper.fyhSetActiveMarker(null);
// }
// window.initFYHSearchResultsMapAndData = initFYHSearchResultsMapAndData;
// window.MapHelper = MapHelper;

/**
 * Handles View More button click within the FYH Search Results panel
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// function fyhSearchResultsViewMore() {
//     if (fyhSearchMapJson != null) {

//         // Grab current number of visible results and the number of results to attempt to fetch
//         var numVisibleResults = MapHelper.fyhSearchVisibleCommunityNodeGuids.length;
//         var numResultsToDisplay = MapHelper.fyhSearchNumResultsDisplayed + MapHelper.FYH_SEARCH_BATCH_SIZE;

//         // Loop through the next batch of results
//         for (var x = MapHelper.fyhSearchNumResultsDisplayed; x < numVisibleResults && x < numResultsToDisplay; x++) {
//             var communityNodeGuid = MapHelper.fyhSearchVisibleCommunityNodeGuids[x];
//             // Make this card visible
//             var card = $(".search-results_wrapper-cell[data-node-guid=" + communityNodeGuid + "]");
//             if (card != null) {
//                 card.addClass("is-visible");
//             }

//             // Increment the visible result count
//             MapHelper.fyhSearchNumResultsDisplayed++;
//         }

//         // Decide if we need to hide the view more button or not
//         if (MapHelper.fyhSearchNumResultsDisplayed < numResultsToDisplay || MapHelper.fyhSearchNumResultsDisplayed >= numVisibleResults) {
//             $(".find-your-home .view-more-communities").hide();
//         }
//         else {
//             $(".find-your-home .view-more-communities").show();
//         }
//     }

//     // Because the sticky map depends on the height of the listing on tablet and desktop, recalculate the 
//     // sticky sizing
//     if( Foundation.MediaQuery.atLeast("medium") ) {
//         $('#fyh-search-sticky').foundation('_calc', true, scroll);
//     }
// }


/**
 * Update display count according to the total number of markers/communities
 * visible in the map viewport 
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// function fyhUpdateDisplayCount() {
//     var numResults = MapHelper.fyhSearchVisibleCommunityNodeGuids.length;
//     $(".search-results-cards-num-results, .search-results-cards-num-results-v2").text(`${numResults} Community Results`);

//     if(numResults === 0 ) {
//         $(".search-results_no-results").removeClass("hide");
//     }
//     else {
//         $(".search-results_no-results").addClass("hide");
//     }
// }

/**
 * Sorts the side results section according to the selected value of the sort dropdown list
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// function fyhSearchResultsSortJson(){
//     var selectedSort = $(".find-your-home #sort-dropdown").val();

//     var sortFunc = sortCommunityByAlpaAsc;
//     switch (selectedSort) {
//         case 'alpha_a-z':
//             sortFunc = sortCommunityByAlpaAsc;
//             break;
//         case 'alpha_z-a':
//             sortFunc = sortCommunityByAlpaDesc;
//             break;
//         case 'price_low-high':
//             sortFunc = sortCommunityByPriceAsc
//             break;
//         case 'price_high-low':
//             sortFunc = sortCommunityByPriceDesc;
//             break;
//         case 'location_a-z':
//             sortFunc = sortCommunityByLocationAsc;
//             break;
//         case 'location_z-a':
//             sortFunc = sortCommunityByLocationDesc;
//             break;
//     }

//     fyhSearchMapJson = fyhSearchMapJson.sort(sortFunc);
//     return fyhSearchMapJson;
// }

/**
 * Sorts the side results section according to the selected value of the sort dropdown list
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// function fyhSearchResultsSortDOM(){
//     var selectedSort = $(".find-your-home #sort-dropdown").val();

//     var cards = $('.search-results_wrapper-cell');
//     switch (selectedSort) {
//         case 'alpha_a-z':
//             // Sort DOM
//             $($('.search-results_wrapper-cell').parent()).html(cards.sort(function(a,b){
//                 var aObject = {
//                     Name: $(a).data("name")
//                 }
//                 var bObject = {
//                     Name: $(b).data("name")
//                 }
//                 return sortCommunityByAlpaAsc(aObject, bObject);
//             }));
//             break;
//         case 'alpha_z-a':
//             // Sort DOM
//             $($('.search-results_wrapper-cell').parent()).html(cards.sort(function(a,b){
//                 var aObject = {
//                     Name: $(a).data("name")
//                 }
//                 var bObject = {
//                     Name: $(b).data("name")
//                 }
//                 return sortCommunityByAlpaDesc(aObject, bObject);
//             }));
//             break;
//         case 'price_low-high':
//             // Sort DOM
//             $($('.search-results_wrapper-cell').parent()).html(cards.sort(function(a,b){
//                 var aObject = {
//                     Name: $(a).data("name"),
//                     PriceMin: $(a).data("start-price")
//                 }
//                 var bObject = {
//                     Name: $(b).data("name"),
//                     PriceMin: $(b).data("start-price")
//                 }
//                 return sortCommunityByPriceAsc(aObject, bObject);
//             }));
//             break;
//         case 'price_high-low':
//             // Sort DOM
//             $($('.search-results_wrapper-cell').parent()).html(cards.sort(function(a,b){
//                 var aObject = {
//                     Name: $(a).data("name"),
//                     PriceMin: $(a).data("start-price")
//                 }
//                 var bObject = {
//                     Name: $(b).data("name"),
//                     PriceMin: $(b).data("start-price")
//                 }
//                 return sortCommunityByPriceDesc(aObject, bObject);
//             }));
//             break;
//         case 'location_a-z':
//             $($('.search-results_wrapper-cell').parent()).html(cards.sort(function(a,b){
//                 var aObject = {
//                     Name: $(a).data("name"),
//                     State: $(a).data("state"),
//                     City: $(a).data("city")
//                 }
//                 var bObject = {
//                     Name: $(b).data("name"),
//                     State: $(b).data("state"),
//                     City: $(b).data("city")
//                 }
//                 return sortCommunityByLocationAsc(aObject, bObject);
//             }));
//             break;
//         case 'location_z-a':
//             $($('.search-results_wrapper-cell').parent()).html(cards.sort(function(a,b){
//                 var aObject = {
//                     Name: $(a).data("name"),
//                     State: $(a).data("state"),
//                     City: $(a).data("city")
//                 }
//                 var bObject = {
//                     Name: $(b).data("name"),
//                     State: $(b).data("state"),
//                     City: $(b).data("city")
//                 }
//                 return sortCommunityByLocationDesc(aObject, bObject);
//             }));
//             break;
//     }
// }

/**
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * 
 * @param {*} a 
 * @param {*} b 
 */
// function sortCommunityByAlpaAsc(a,b) {
//     if (a.Name.toLowerCase() < b.Name.toLowerCase()) { return -1; }
//     else if (a.Name.toLowerCase() > b.Name.toLowerCase()) { return 1; }
//     else { return 0; }
// }

/**
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * 
 * @param {*} a 
 * @param {*} b 
 */
// function sortCommunityByAlpaDesc(a,b) {
//     return -1 * sortCommunityByAlpaAsc(a,b);
// }

/**
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * 
 * @param {*} a 
 * @param {*} b 
 */
// function sortCommunityByPriceAsc(a,b) {
//     if (a.PriceMin < b.PriceMin) { return -1; }
//     else if (a.PriceMin > b.PriceMin) { return 1; }
//     else {
//         return sortCommunityByAlpaAsc(a,b);
//     }
// }

/**
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * 
 * @param {*} a 
 * @param {*} b 
 * @returns 
 */
// function sortCommunityByPriceDesc(a,b) {
//     if (a.PriceMin > b.PriceMin) { return -1; }
//     else if (a.PriceMin < b.PriceMin) { return 1; }
//     else {
//         return sortCommunityByAlpaAsc(a,b);
//     }
// }

/**
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * 
 * @param {*} a 
 * @param {*} b 
 */
// function sortCommunityByLocationAsc(a,b) {
//     if (a.State < b.State) { return -1; }
//     else if (a.State > b.State) { return 1; }
//     else {
//         if (a.City < b.City) { return -1; }
//         else if (a.City > b.City) { return 1; }
//         else {
//             // Name in ascending fashion
//             return sortCommunityByAlpaAsc(a,b);
//         }
//     }
// }

/**
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 * 
 * @param {*} a 
 * @param {*} b 
 */
// function sortCommunityByLocationDesc(a,b) {
//     if (a.State > b.State) { return -1; }
//     else if (a.State < b.State) { return 1; }
//     else {
//         if (a.City > b.City) { return -1; }
//         else if (a.City < b.City) { return 1; }
//         else {
//             // Name in ascending fashion
//             return sortCommunityByAlpaAsc(a,b);
//         }
//     }
// }

/**
 * Resets the FYH search results panel by resetting the num results dispalyed counter and resetting
 * the visible community data structure. Also hides all the communities in the results section and attempts
 * to load in a new fresh batch of visible communities.
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// function fyhSearchResultsReset() {
//     MapHelper.fyhSearchVisibleCommunityNodeGuids = [];
//     MapHelper.fyhSearchNumResultsDisplayed = 0;

//     // Remove the is-visible class from the results
//     $(".search-results_wrapper-cell").removeClass("is-visible");

//     // By default hide the view more button
//     $(".find-your-home .view-more-communities").hide();

//     // Get list of all markers and update global fyhSearchVisibleCommunityNames
//     if (MapHelper.fyhSearchMapClusterer != null) {
//         var allClusters = MapHelper.fyhSearchMapClusterer.getClusters();
//         var visibleClusters = [];
//         allClusters.forEach(function (cluster) {
//             if (MapHelper.fyhSearchMap.getBounds().contains(cluster.getCenter()) === true) {
//                 visibleClusters.push(cluster);
//             }
//         });

//         // Now that we have all the visible clusters, loop through each cluster to get each marker
//         // so that we can hide
//         var visibleCommunityGuids = [];

//         visibleClusters.forEach(function (cluster) {
//             var markers = cluster.getMarkers();
//             markers.forEach(function (marker) {
//                 var communityNodeGuid = marker.customInfo.nodeGuid;

//                 // Add this community to visible community data structure
//                 visibleCommunityGuids.push(communityNodeGuid);
//             });
//         });

//         // Sort fyhSearchMapJson and update MapHelper.fyhSearchCommunityNodeGuidsSorted
//         fyhSearchMapJson =  fyhSearchResultsSortJson();
//         MapHelper.fyhSearchCommunityNodeGuidsSorted = fyhSearchMapJson.map(function(community){
//             return community.NodeGUID;
//         });

//         // Reset the map and set the visible community data structure...Order the visible community list according current sort selection
//         MapHelper.fyhSearchCommunityNodeGuidsSorted.forEach( function(communityGuid){
//             if( visibleCommunityGuids.includes(communityGuid) ){
//                 MapHelper.fyhSearchVisibleCommunityNodeGuids.push(communityGuid);
//             }
//         });
//     }

//     // Now Sort Results DOM
//     fyhSearchResultsSortDOM();

//     // Now that DOM has changed, make sure to re-init the favoriting
//     initFavoriteButtons($(".search-results .card-like-button"));

//     // Try loading initial batch of results
//     fyhSearchResultsViewMore();

//     // Update the number of results based on the number of DOM elements (which indicates total number of query results)
//     fyhUpdateDisplayCount();

//     // Add event listener to on hover on listing cards to highlight the active community
//     MapHelper.initFyhSearchResultCardListeners();
// }

/**
 * Forces the map to remove all markers and recreate markers given the latest map JSON dataset.
 *
 * Intended to be called by backend with json string to refresh map markers
 *
 * See: window.fyhSearchMapJson
 * 
 * @deprecated moving to `FindYourHome` class in `find-your-home.js`
 */
// function refreshFYHSearchResultsMap() {
//     // Data from BE will be stored in hidden field textbox
//     if (IS_LOCALHOST === false) {
//         var jsonData = JSON.parse($("#hiddenHomeSearchFormData").val());

//         if (jsonData) {
//             window.fyhSearchMapJson = jsonData;
//         }
//     }

//     // Trigger re-init
//     initFYHSearchResultsMapAndData(true);
// }

/**
 * @deprecated moving to `EventMap` class in `event-map.js`
 * 
 * Initializes the Event Details Map within the Events Page
 */
// function initEventDetailsMap() {
//     var eventDetailsMap = document.getElementById('event-details-map')
//     if (eventDetailsMap == null) {
//         return;
//     }
//     var eventLat = $(eventDetailsMap).attr("eventLat");
//     var eventLng = $(eventDetailsMap).attr("eventLng");
//     if (IS_LOCALHOST === true) {
//         var eventLat = 33.596891;
//         var eventLng = -117.658156;
//     }
//     var map = new google.maps.Map(eventDetailsMap, {
//         zoom: 16,
//         center: new google.maps.LatLng(eventLat, eventLng),
//         mapTypeId: 'roadmap',
//         styles: [
//             {elementType: 'geometry', stylers: [{saturation: '-75'}]},
//             {featureType: 'road',elementType: 'geometry',stylers: [{saturation: '-75'}]},
//             {featureType: 'road',elementType: 'geometry.stroke',stylers: [{saturation: '-75'},{color: '#c9c1a9'}]},
//             {featureType: 'road.highway',elementType: 'geometry',stylers: [{saturation: '-75'}]},
//             {featureType: 'road.highway',elementType: 'geometry.stroke',stylers: [{saturation: '-75'},{color: '#c9c1a9'}]},
//             {featureType: 'transit',elementType: 'geometry',stylers: [{saturation: '-75'}]},
//         ]
//     });
//     var details = [
//         {
//             position: new google.maps.LatLng(eventLat, eventLng),
//         }
//     ];
//     // Create markers.
//     var markers = [];
//     var infoWin = new google.maps.InfoWindow();
//     details.forEach(function (details) {
//         var marker = new google.maps.Marker({
//             position: details.position,
//             map: map
//         });
//     });
// }

/*
* Pre Loader button
* Used on filter forms adjust designs in loadingoverlay.js
*/
function initPreLoader() {
    var PRE_LOADER_CLICK_EVENT =  "click.preloaderClick";

    $(".pre-loader").off(PRE_LOADER_CLICK_EVENT).on(PRE_LOADER_CLICK_EVENT,function (f) {
        if (IS_LOCALHOST == true) {
            f.preventDefault(); //prevent refresh
        }

        showPreLoader();
    });
}
window.initPreLoader = initPreLoader;

/**
 * 
 * @param {*} elem elem for which to remove the overlay from...omit to remove overlay from page MAIN element
 */
function hidePreLoader(elem) {
    if(elem) {
        $(elem).LoadingOverlay("hide", true);
    }
    else {
        $("main").LoadingOverlay("hide", true);
    }

    $(".show-for-sr").removeClass('show');
}
window.hidePreLoader = hidePreLoader;

/**
 * 
 * @param {*} elem elem for which to display overlay on top off...omit to display on page MAIN element
 */
function showPreLoader(elem) {
    let options = { imageColor: "rgba(0,172,201)", maxSize: 60};
    if(elem) {
        // Show full page LoadingOverlay
        $(elem).LoadingOverlay("show", options);
    }
    else {
        // Show full page LoadingOverlay
        $("main").LoadingOverlay("show", options);
    }

    $(".show-for-sr").addClass('show');
}
window.showPreLoader = showPreLoader;


/*
* Selected Area Size
*This is used to check the size of contact area and then apply that height to the selected
* Area asied
* This is used on the contact form interest list
*/
function intSelectedAreaSize() {
    $('.interest-list-options').click(function (e) {
        e.preventDefault();
        var divHeight = $('.contact-interest-area').height() - 45;
        $('.selected-aside').css('max-height', divHeight + 'px');
        $('.selected-aside').addClass('show');
    });
}

var hiddenFieldProcessedValue = null;
function updateDropdownOptions(sourceObject) {
    // Data from BE will be stored in hidden field textbox
    var hiddenFieldData = $("#ddlHiddenField").val();
    var selectedIndex = $("#selectedDDIndex").val();

    if (hiddenFieldData != null && hiddenFieldData.length > 0 && hiddenFieldProcessedValue != hiddenFieldData + selectedIndex) {
        hiddenFieldProcessedValue = hiddenFieldData + selectedIndex;
        initCustomDropdowns(hiddenFieldData);
    }
}
window.updateDropdownOptions = updateDropdownOptions; // Make this accessible in under window to be executed by BE

/** States, Regions, Master plan and Communities filter dropdowns logic of Blog landing page  - Start **/

/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var dropdownDataJson = $("#HiddenDropDownDataField").val();

/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
// var jsonDDData;
// if (dropdownDataJson) {
//     jsonDDData = JSON.parse(dropdownDataJson);
// }
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var ddStates = $('#ddlStates');
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var ddRegions = $('#ddlRegions');
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var ddcommunities = $('#ddlCommunities');
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var pagerefreshhappened = false;
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var pagerefreshhappenedCommunity = false;
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var numberofstatechangecall = 0;
/**
 * @deprecated see `StateRegionCommunitySelect` class within `lib/forms/state-region-communit-select.js` for state/region/community dropdown logic
 */
//var numberofregionchangecall = 0;

/**
 * @deprecated moving to `BlogListing` class in `blog-listing.js`
 */
// function intiPopulateBlogLandingStatesDD() {
//     pagerefreshhappened = true;
//     pagerefreshhappenedCommunity = true;

//     if (jsonDDData && $('#ddlStates').length !== 0) {
//         //Get state dropdown
//         var ddStates = $('#ddlStates');
//         var selectedStateSession = $("#selectedStateSession").get(0).value;
//         var stateindex = -1;

//         var stateindex = -1;
//         ddStates.empty();
//         ddStates.append('<option selected="true">All States</option>');
//         for (var i = 0; i < jsonDDData.length; i++) {
//             ddStates.append($('<option></option>').attr('value', jsonDDData[i].StatesList[0].StateNameForValue).text(jsonDDData[i].StatesList[0].StateName));

//             if(selectedStateSession == jsonDDData[i].StatesList[0].StateNameForValue)
//                 {
//                 stateindex = i;
//             }
//         }
//         ddStates.prop('selectedIndex', stateindex + 1);
//         ddStates.trigger("change");

//         initCustomDropdowns(ddStates);

//     }
// }

/**
 * @deprecated moving to `BlogListing` class in `blog-listing.js`
 */
// $("#ddlStates").change(function () {
//     numberofstatechangecall++;
//     var regionsessionindex = 0;

//     if ($(this[this.selectedIndex]).text() != "All States" && $(this[this.selectedIndex]).text()!="") {
//         var index = $('#ddlStates').get(0).selectedIndex;
//         var indexmodified = index - 1;
//         var numRegionsInState = jsonDDData[indexmodified].StatesList[0].Region.length;
//         ddRegions.removeAttr("disabled");
//         ddRegions.empty();


//         // Read region from the session
//         var selectedRegionSession = $("#selectedRegionSession").get(0).value;
//         if(selectedRegionSession !== "" && selectedRegionSession !== "undefined")
//         {
//             for (var i = 0; i < jsonDDData[indexmodified].StatesList[0].Region.length; i++) {

//                 if(selectedRegionSession === jsonDDData[indexmodified].StatesList[0].Region[i].RegionNodeGUID)
//                     {
//                     regionsessionindex = i;
//                 }
//             }
//         }

//         if (numRegionsInState != 1) {
//             ddRegions.append('<option selected="true">All Regions</option>');

//             // Make sure to disable the communities dropdown and reset it back to position 0
//             // ddcommunities.prop('selectedIndex', 0);
//             // ddcommunities.attr('disabled', 'disabled');
//             // initCustomDropdowns(ddcommunities);
//         }
//         else {
//             ddRegions.append('<option>All Regions</option>');
//             // We will set the selectedIndex later
//         }

//         for (var i = 0; i < numRegionsInState; i++) {
//             ddRegions.append($('<option></option>').attr('value', jsonDDData[indexmodified].StatesList[0].Region[i].RegionNodeGUID).text(jsonDDData[indexmodified].StatesList[0].Region[i].RegionName));

//             // If the region only has one region, autoselect it
//             if (numRegionsInState === 1 && i == 0) {
//                 ddRegions.prop('selectedIndex', regionsessionindex + 1);

//                 initCustomDropdowns(ddcommunities);
//             }
//         }

//         // distinguish between first refresh and dropdown changes
//         if(numRegionsInState !== 1)
//         {
//             if(pagerefreshhappened && numberofstatechangecall === 1){
//                 if(selectedRegionSession === "All Regions") {regionsessionindex = -1;}
//                 ddRegions.prop('selectedIndex', regionsessionindex + 1);
//                 pagerefreshhappened = false;
//             }
//             else{
//                 ddRegions.prop('selectedIndex', 0);
//             }
//         }

//         // Fire the selected event so that the communities dropdown updates
//         ddRegions.change();

//         initCustomDropdowns(ddRegions);

//     }
//     else {

//         // Reset the regions and communities  and trigger both dropdown changes
//         ddRegions.prop('selectedIndex', 0);
//         ddRegions.attr('disabled', 'disabled');
//         ddcommunities.prop('selectedIndex', 0);
//         ddcommunities.attr('disabled', 'disabled');
//         ddRegions.change();
//         ddcommunities.change();


//     }
// });

/**
 * @deprecated moving to `BlogListing` class in `blog-listing.js`
 */
// $("#ddlRegions").change(function () {

//     var communitysessionindex = 0;
//     numberofregionchangecall++;

//     if ($(this[this.selectedIndex]).text() != "All Regions" && $(this[this.selectedIndex]).text() != "") {
//         var index = $('#ddlRegions').get(0).selectedIndex;
//         var selectedStateIndex = $("#ddlStates").get(0).selectedIndex;
//         var modifiedSelectedStateIndex = selectedStateIndex - 1;
//         var indexmodified = index - 1;
//         ddcommunities.removeAttr("disabled");
//         ddcommunities.empty();
//         ddcommunities.append('<option selected="true">All Communities</option>');
//         ddcommunities.prop('selectedIndex', 0);

//         if(modifiedSelectedStateIndex > -1)
//         {
//             var jsondata = jsonDDData[modifiedSelectedStateIndex];
//             var statelist = jsondata.StatesList[0];
//         }

//         var selectedCommunitySession = $("#selectedCommunitySession").get(0).value;

//         if(indexmodified > -1)
//         {
//             for (var i = 0; i < jsonDDData[modifiedSelectedStateIndex].StatesList[0].Region[indexmodified].Communities.length; i++) {
//                 ddcommunities.append($('<option></option>').attr('value', jsonDDData[modifiedSelectedStateIndex].StatesList[0].Region[indexmodified].Communities[i].CommunityNodeGUID).text(jsonDDData[modifiedSelectedStateIndex].StatesList[0].Region[indexmodified].Communities[i].CommunityName));

//                 if(jsonDDData[modifiedSelectedStateIndex].StatesList[0].Region[indexmodified].Communities[i].CommunityNodeGUID === selectedCommunitySession)
//                 {
//                     communitysessionindex = i;
//                 }

//             }
//         }

//     if((jsonDDData[modifiedSelectedStateIndex].StatesList[0].Region[indexmodified].Communities.length > 1 && numberofregionchangecall !== 1) || selectedCommunitySession === "All Communities")
//     {
//             ddcommunities.prop('selectedIndex', 0);
//     }else if(numberofregionchangecall === 1){
//             ddcommunities.prop('selectedIndex', communitysessionindex + 1);
//         }


//         initCustomDropdowns(ddcommunities);
//     }
//     else {
//         // Reset the communities  and trigger the dropdown changes
//         ddcommunities.prop('selectedIndex', 0);
//         ddcommunities.attr('disabled', 'disabled');
//         ddcommunities.change();
//     }
// });
/** States, Regions, Master plan and Communities filter dropdowns logic of Blog landing page  - End **/


/**
 * @deprecated moving to `BlogListing` class in `blog-listing.js`
 * Get the selected values from each dropdown and build the JSON string used to pass to the BE
 * @param {elem} elem DOM element that is triggering this even
 */
// function initGetBlogFiltersData() {
//     // Make sure we are on the Blog LP page
//     if ($(".blog-filter-container").length < 1) {
//         return;
//     }

//     // Set up the apply filter click listener for Home Search forms
//     $(".shea-form-input-button").click(function (e) {
//         if (IS_LOCALHOST == true) {
//             e.preventDefault();
//         }
//         applyBlogFiltersData();
//     });

//     // Set up the sort dropdown listener which may also trigger filtering
//     $(".blog-filter-container #ddlSort").change(function () {
//         applyBlogFiltersData();
//     });
// }

/**
 * @deprecated moving to `BlogListing` class in `blog-listing.js`
 */
// function applyBlogFiltersData() {
//     // Get the selected values from each dropdown
//     var formWrapper = $("#filterContainerBlog");
//     var formWrapperCheckboxes = $("#additionalFilterContainerBlog");
//     var dropdowns = formWrapper.find("select.shea-custom-dropdown");
//     var filterValues = {};
//     var i = 0;
//     dropdowns.each(function (index, elem) {
//         // Grab dropdown and the name
//         var dropdown = $(elem);
//         var dropdownName = dropdown.attr("name");
//         var State = "State";
//         var RegionNodeGUID = "RegionNodeGUID";
//         var CommunityNodeGUID = "CommunityNodeGUID";
//         var sortBySelection = "sortBySelection";
//         var Tags = "Tags";

//         // Grab all of the selected values for this dropdown
//         var dropdownValues = dropdown.select2("data");
//         // Add values to filterValues object indexed by the dropdown name
//         if (i == 0) {
//             filterValues[State] = dropdown.val();
//         }
//         else if (i == 1) {
//             filterValues[RegionNodeGUID] = dropdown.val();
//         }
//         else if (i == 2) {
//             filterValues[CommunityNodeGUID] = dropdown.val();
//         }
//         i++;

//     });

//     var values = [];
//     // Now grab the checkbox values
//     $('input:checkbox[name="Tags"]:checked').each(function () {
//         values.push(this.value);

//     });
//     filterValues["Tags"] = values;

//     filterValues["sortBySelection"] = $("#ddlSort").val();

//     // Place JSON Data within the hidden textbox
//     var hiddenTextBox = $("#hiddenBlogFilterValues");
//     var filterValuesJson = JSON.stringify(filterValues);
//     $(hiddenTextBox).val(JSON.stringify(filterValues));

// }

/**
 * @deprecated moving to `NewsEventListing` class in `news-event-listing.js`
 * 
 * Initializes various handlers for the News and Events LP filters
 */
// function initNewsEventsFilterForm() {

//     // Events Page
//     var selectedEventRegionSession = $("#selectedEventRegionSession");
//     var selectedEventCommunitySession = $("#selectedEventCommunitySession");

//     // News Page
//     var selectedNewsRegionSession = $("#selectedNewsRegionSession");
//     var selectedNewsCommunitySession = $("#selectedNewsCommunitySession");

//     // Make sure we are on the News Events page
//     if ($(".news-events-tab").length < 1) {
//         return;
//     }

//     // The News and Events tab should keep their status
//     // panel1c = Event
//     // panel2c = News
//     var tabSession = $("#selectedTabSession").get(0).value;
//     if(tabSession === "Event")
//     {
//         $("#panel1c-label").prop("tabindex","0");
//         $("#panel2c-label").prop("tabindex","-1");

//         $("#panel1c-label").prop("aria-selected","true");

//         $(".global-tabs-title").get(0).classList.add("is-active");
//         $(".global-tabs-title").get(1).classList.remove("is-active");
//     }
//     else if(tabSession === "News")
//     {
//         $("#panel1c-label").prop("tabindex","-1");
//         $("#panel2c-label").prop("tabindex","0");

//         $("#panel2c-label").prop("aria-selected","true");

//         $(".global-tabs-title").get(0).classList.remove("is-active");
//         $(".global-tabs-title").get(1).classList.add("is-active");
//     }

//     // Set up the apply filter click listener for Home Search forms
//     $(".forms-loader-container .shea-form-input-button").click(function (e) {
//         if (IS_LOCALHOST == true) {
//             e.preventDefault();
//         }

//         // Apply the filters
//         applyNewsEventsFilters(this);
//     });

//     // Grab data from hidden field to help populate the dropdowns
//     var hiddenDropdownDataField = null;
//     var newsHiddenDropdownDataField = $("#hiddenNewsDropdownData");
//     var eventHiddenDropdownDataField = $("#hiddenEventDropdownData");

//     // Session values
//     var selectedEventStateSession = $("#selectedEventStateSession").get(0).value;
//     var selectedNewsStateSession = $("#selectedNewsStateSession").get(0).value;

//     if (newsHiddenDropdownDataField.length > 0) {
//         hiddenDropdownDataField = $(newsHiddenDropdownDataField);
//     }
//     else if (eventHiddenDropdownDataField.length > 0) {
//         hiddenDropdownDataField = $(eventHiddenDropdownDataField);
//     }

//     // Check to see if hidden field was found...if not break and do not proceed
//     if (hiddenDropdownDataField == null) {
//         return;
//     }

//     var filterContainer = $(".filter-container");

//     // Parse the hidden fields JSON
//     var jsonString = hiddenDropdownDataField.val();
//     var jsonData = JSON.parse(jsonString);
//     if (jsonData) {
//         //Get state dropdown and set its options given the JSON data
//         var stateDropdown = $(".filter-container .states-dropdown");
//         stateDropdown.empty();
//         stateDropdown.append('<option selected="true" value="any">All States</option>');

//         var stateeventsessionindex = 0;
//         var statenewssessionindex = 0;

//         for (var i = 0; i < jsonData.length; i++) {
//             stateDropdown.append($('<option></option>').attr('value', jsonData[i].StateAbbreviation).text(jsonData[i].State));

//             if(jsonData[i].StateAbbreviation === selectedEventStateSession)
//             {
//                 stateeventsessionindex = i + 1;
//             }

//             if(jsonData[i].StateAbbreviation === selectedNewsStateSession)
//             {
//                 statenewssessionindex = i + 1;
//             }
//         }
//         $(filterContainer).find("#events-states-dropdown").prop('selectedIndex',stateeventsessionindex);
//         $(filterContainer).find("#news-states-dropdown").prop('selectedIndex',statenewssessionindex);

//         var eventsstatesdropdown = $(filterContainer).find("#events-states-dropdown");
//         var newsstatesdropdown = $(filterContainer).find("#news-states-dropdown");
//         // Events
//         newseventStateChangedRefresh(selectedEventStateSession,eventsstatesdropdown, jsonData
//                                     ,$(filterContainer).find("#events-regions-dropdown")
//                                     ,$(filterContainer).find("#events-communities-dropdown")
//                                     ,selectedEventRegionSession
//                                     ,selectedEventCommunitySession);

//         // News                            
//         newseventStateChangedRefresh(selectedNewsStateSession,newsstatesdropdown, jsonData
//                                     ,$(filterContainer).find("#news-regions-dropdown")
//                                     ,$(filterContainer).find("#news-communities-dropdown")
//                                     ,selectedNewsRegionSession
//                                     ,selectedNewsCommunitySession);

//         // Set the dropdown to re-init
//         initCustomDropdowns(stateDropdown);

//     }

//     var statesDropdown = $(filterContainer).find(".states-dropdown");
//     var regionsDropdown = $(filterContainer).find(".regions-dropdown");
//     var communitiesDropdown = $(filterContainer).find(".communities-dropdown");

//     //
//     // Add on dropdown selection handlers to set the options for the succeeding dropdown
//     //
//     $(statesDropdown).change(function () {
//         var selectedValue = $(this).find("option:selected").val();

//         // Get reference to this dropdown sibling regions dropdown
//         var parentFilterContainer = $(this).parents(".filter-container");
//         var regionsSiblingDropdown = $($(parentFilterContainer).find(".regions-dropdown"));
//         var communitiesSiblingDropdown = $($(parentFilterContainer).find(".communities-dropdown"));
//         if (selectedValue !== "any" && typeof(selectedValue) !== "undefined") {
//             // Grab the list of regions for the selected state
//             for (var i = 0; i < jsonData.length; i++) {
//                 var state = jsonData[i];
//                 if (state["StateAbbreviation"] === selectedValue) {
//                     //Get list of the regions and create new option for each
//                     var stateRegions = state["Regions"];
//                     var doesStateOnlyHaveOneRegion = (stateRegions == null) ? false : true;

//                     // Enable the sibling region dropdown and populate it with the correct options from
//                     // the JSON data
//                     regionsSiblingDropdown.removeAttr("disabled");
//                     regionsSiblingDropdown.empty();

//                     // Auto select region if there is only one region in the data set
//                     if (stateRegions.length === 1) {
//                         regionsSiblingDropdown.append('<option value="any">All Regions</option>');
//                         regionsSiblingDropdown.prop('selectedIndex', 1);
//                     }
//                     // Else autoselect the first default option
//                     else {
//                         regionsSiblingDropdown.append('<option selected="true" value="any">All Regions</option>');
//                         regionsSiblingDropdown.prop('selectedIndex', 0);
//                     }

//                     stateRegions.forEach(function (region, index) {
//                         var regionOption = $('<option></option>')
//                             .attr('value', region["NodeGUID"])
//                             .text(region["Name"])
//                             .prop("selected", stateRegions.length === 1);
//                         regionsSiblingDropdown.append(regionOption);
//                     });

//                     if (stateRegions.length === 1) {
//                         // Simulate the selection of this one region to force the community ddl to update
//                         regionsSiblingDropdown.change();
//                         communitiesSiblingDropdown.prop('selectedIndex', 0);
//                     }
//                     else {
//                         communitiesSiblingDropdown.prop('selectedIndex', 0);
//                         communitiesSiblingDropdown.attr('disabled', 'disabled');
//                     }
//                     break;
//                 }
//             };
//             initCustomDropdowns(regionsSiblingDropdown);

//         }
//         else {
//             regionsSiblingDropdown.prop('selectedIndex', 0);
//             regionsSiblingDropdown.attr('disabled', 'disabled');
//             initCustomDropdowns(regionsSiblingDropdown);
//             communitiesSiblingDropdown.prop('selectedIndex', 0);
//             communitiesSiblingDropdown.attr('disabled', 'disabled');
//             initCustomDropdowns(communitiesSiblingDropdown);
//         }
//     });

//     $(regionsDropdown).change(function () {
//         var selectedText = $(this).find("option:selected").text();

//         // Get reference to this dropdown sibling regions dropdown
//         var parentFilterContainer = $(this).parents(".filter-container");
//         var statesSiblingDropdown = $($(parentFilterContainer).find(".states-dropdown"));
//         var communitiesSiblingDropdown = $($(parentFilterContainer).find(".communities-dropdown"));

//         if (selectedText !== "All Regions" && selectedText !== "") {
//             communitiesSiblingDropdown.removeAttr("disabled");
//             communitiesSiblingDropdown.empty();
//             communitiesSiblingDropdown.append('<option selected="true" value="any">All Communities</option>');
//             communitiesSiblingDropdown.prop('selectedIndex', 0);

//             // Grab the list of regions for the selected state
//             var selectedStateText = statesSiblingDropdown.find("option:selected").text();
//             for (var i = 0; i < jsonData.length; i++) {
//                 var state = jsonData[i];
//                 if (state["State"] === selectedStateText) {
//                     //Get list of the regions and create new option for each
//                     var stateRegions = state["Regions"];

//                     for (var x = 0; x < stateRegions.length; x++) {
//                         var region = stateRegions[x];
//                         if (region["Name"] == selectedText) {
//                             // Grab this region's communities
//                             var regionCommunities = region["Communities"];
//                             regionCommunities.forEach(function (community) {
//                                 var communityOption = $('<option></option>')
//                                     .attr('value', community["NodeGUID"])
//                                     .text(community["Name"]);
//                                 communitiesSiblingDropdown.append(communityOption);
//                             });

//                             // Reinit dropdown
//                             initCustomDropdowns(communitiesSiblingDropdown);

//                             break;
//                         }
//                     }
//                     break;
//                 }
//             };
//         }
//         else {
//             communitiesSiblingDropdown.prop('selectedIndex', 0);
//             communitiesSiblingDropdown.attr('disabled', 'disabled');

//             // Reinit dropdown
//             initCustomDropdowns(communitiesSiblingDropdown);
//         }
//     });
// }

/**
 * @deprecated moving to `NewsEventListing` class in `news-event-listing.js`
 * 
 */
// function newseventStateChangedRefresh(selectedVal, stateDropdown,jsonData,regionsDropdown
//     ,communitiesDropdown
//     ,selectedEventRegionSession
//     ,selectedEventCommunitySession)
// {
//     var selectedStateValue = selectedVal;

//     // Get reference to this dropdown sibling regions dropdown
//     var parentFilterContainer = stateDropdown;
//     var regionsSiblingDropdown = regionsDropdown;
//     var communitiesSiblingDropdown = communitiesDropdown;
//     if (selectedStateValue !== "any" && typeof(selectedStateValue) !== "undefined") {
//         // Grab the list of regions for the selected state
//         for (var i = 0; i < jsonData.length; i++) {
//             var state = jsonData[i];
//             if (state["StateAbbreviation"] === selectedStateValue) {
//                 //Get list of the regions and create new option for each
//                 var stateRegions = state["Regions"];
//                 var doesStateOnlyHaveOneRegion = (stateRegions == null) ? false : true;

//                 // Enable the sibling region dropdown and populate it with the correct options from
//                 // the JSON data
//                 regionsSiblingDropdown.removeAttr("disabled");
//                 regionsSiblingDropdown.empty();

//                 // Auto select region if there is only one region in the data set
//                 if (stateRegions.length === 1) {
//                     regionsSiblingDropdown.append('<option value="any">All Regions</option>');
//                     regionsSiblingDropdown.prop('selectedIndex', 1);
//                 }
//                 // Else autoselect the first default option
//                 else {
//                     regionsSiblingDropdown.append('<option selected="true" value="any">All Regions</option>');
//                     regionsSiblingDropdown.prop('selectedIndex', 0);
//                 }

//                 // Prop the region dropdown to the right index
//                 var propindex = 0;
//                 var seletedregionname = "";
//                 stateRegions.forEach(function (region, index) {
//                     var regionOption = $('<option></option>')
//                         .attr('value', region["NodeGUID"])
//                         .text(region["Name"])
//                         .prop("selected", stateRegions.length === 1);
//                     regionsSiblingDropdown.append(regionOption);

//                     if(region["NodeGUID"] === selectedEventRegionSession.get(0).value) 
//                     {
//                         propindex = index + 1;
//                         seletedregionname = region["Name"];
//                     }

//                 });
//                 regionsSiblingDropdown.prop('selectedIndex', propindex);

//                 eventCommunityChangeRefresh(seletedregionname,selectedStateValue,stateDropdown,communitiesDropdown,selectedEventCommunitySession,jsonData);

//                 break;
//             }
//         };
//         initCustomDropdowns(regionsSiblingDropdown);

//     }
//     else {
//         regionsSiblingDropdown.prop('selectedIndex', 0);
//         regionsSiblingDropdown.attr('disabled', 'disabled');
//         initCustomDropdowns(regionsSiblingDropdown);
//         communitiesSiblingDropdown.prop('selectedIndex', 0);
//         communitiesSiblingDropdown.attr('disabled', 'disabled');
//         initCustomDropdowns(communitiesSiblingDropdown);
//     }
// }

/**
 * @deprecated moving to `NewsEventListing` class in `news-event-listing.js`
 * 
 */
// function eventCommunityChangeRefresh(selectedRegion,selectedStateValue,stateDropdown
//                                     ,communitiesDropdown
//                                     ,selectedEventCommunitySession
//                                     ,jsonData)
// {
//     // Get reference to this dropdown sibling regions dropdown
//     var statesSiblingDropdown = stateDropdown;
//     var communitiesSiblingDropdown = communitiesDropdown;

//     if (selectedRegion !== "All Regions" && selectedRegion !== "") {
//         communitiesSiblingDropdown.removeAttr("disabled");
//         communitiesSiblingDropdown.empty();
//         communitiesSiblingDropdown.append('<option selected="true" value="any">All Communities</option>');
//         communitiesSiblingDropdown.prop('selectedIndex', 0);

//         // Grab the list of regions for the selected state
//         //var selectedStateText = statesSiblingDropdown.find("option:selected").text();
//         for (var i = 0; i < jsonData.length; i++) {
//             var state = jsonData[i];
//             if (state["StateAbbreviation"] === selectedStateValue) {
//                 //Get list of the regions and create new option for each
//                 var stateRegions = state["Regions"];

//                 var commpropindex = 0;
//                 for (var x = 0; x < stateRegions.length; x++) {
//                     var region = stateRegions[x];
//                     if (region["Name"] == selectedRegion) {
//                         // Grab this region's communities
//                         var regionCommunities = region["Communities"];
//                         regionCommunities.forEach(function (community, index) {
//                             var communityOption = $('<option></option>')
//                                 .attr('value', community["NodeGUID"])
//                                 .text(community["Name"]);
//                             communitiesSiblingDropdown.append(communityOption);

//                                 if(community["NodeGUID"] === selectedEventCommunitySession.get(0).value)
//                                 {
//                                 commpropindex = index + 1;
//                             }
//                         });

//                         communitiesSiblingDropdown.prop('selectedIndex', commpropindex);
//                             if(commpropindex > 0)
//                             {
//                             communitiesSiblingDropdown.removeAttr('disabled');
//                         }
//                         // Reinit dropdown
//                         initCustomDropdowns(communitiesSiblingDropdown);

//                         break;
//                     }
//                 }
//                 break;
//             }
//         };
//     }
//     else {
//         communitiesSiblingDropdown.prop('selectedIndex', 0);
//         communitiesSiblingDropdown.attr('disabled', 'disabled');

//         // Reinit dropdown
//         initCustomDropdowns(communitiesSiblingDropdown);
//     }
// }

/**
 * @deprecated moving to `NewsEventListing` class in `news-event-listing.js`
 * 
 * Get the selected values from each dropdown and checkbox and build the JSON string used to pass to the BE
 *
 * @param {elem} elem DOM element that is triggering this even
 */
// function applyNewsEventsFilters(elem) {
//     // Get the selected values from each dropdown (make sure we are retrieving values from the correct
//     // fields e.g., mobile form or desktop form)
//     var formWrapper = $(elem).parents(".filter-container");
//     var dropdowns = formWrapper.find("select.shea-custom-dropdown");
//     var filterValues = {};
//     dropdowns.each(function (index, elem) {
//         // Grab dropdown and the name
//         var dropdown = $(elem);
//         var dropdownName = dropdown.attr("name");

//         // Grab all of the selected values for this dropdown
//         var dropdownValues = dropdown.select2("data");
//         var values = [];
//         dropdownValues.forEach(function (value) {
//             values.push(value.id);
//         })

//         // Add values to filterValues object indexed by the dropdown name
//         filterValues[dropdownName] = values;
//     });

//     // Now grab the checkbox values
//     var checkboxes = formWrapper.find("input[type=checkbox]");
//     checkboxes.each(function (index, value) {
//         var isChecked = $(this).is(":checked");
//         var checkboxName = $(this).attr("name");
//         var checkboxValue = $(this).val();

//         // Create an empty array for this checkbox group/name if needed
//         if (filterValues[checkboxName] == null) {
//             filterValues[checkboxName] = [];
//         }

//         if (isChecked === true) {
//             filterValues[checkboxName].push(checkboxValue);
//         }

//     });

//     // Place JSON Data within the hidden textbox
//     var hiddenTextBox = null;
//     var eventHiddenTextBox = $(formWrapper.find("#hiddenEventFilterValues"));
//     var newsHiddenTextBox = $(formWrapper.find("#hiddenNewsFilterValues"));
//     if (eventHiddenTextBox.length > 0) {
//         hiddenTextBox = $(eventHiddenTextBox);
//     }
//     else if (newsHiddenTextBox.length > 0) {
//         hiddenTextBox = $(newsHiddenTextBox);
//     }

//     var filterValuesJson = JSON.stringify(filterValues);
//     hiddenTextBox.val(filterValuesJson);
// }



/* Retrieves the value of the specified URL parameter
 *
 * See: https://davidwalsh.name/query-string-javascript
 * @param {String} name Name of Url query parameter to retrieve value of
 */
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/* Retrieves the values of the specified URL parameter as an array
 *
 * See: https://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
 * @param {String} name Name of Url query parameter to retrieve value of
 */
function getUrlParameterArray(name) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    var parameters = [];

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === name) {
            var value = (sParameterName[1] === undefined ? "" : sParameterName[1]);
            parameters.push(value);
        }
    }

    return parameters;
};

//Function to detect and close mobile drilldown menu if open on tablet
function initCheckMshDrilldown() {
    if($('#header-msh-megamenu-drilldown')) {
        $("a[data-toggle='header-msh-megamenu-drilldown']").click(function () {
            $(window).on('changed.zf.mediaquery', function() {
                $('#header-msh-megamenu-drilldown').toggleClass('is-open');
            });
        });
    }
}

/**
 * @deprecated see 'LotMap` in `/lib/lot-map.js` and `CommunitySitemap` in `community-sitemap.js`
 * 
 * Handles the initialization of the Community Lot Map
 */
// function initCommunityLopMapSVG() {
//     // First check for existence of hidden field that marks a Community Lot Map existence
//     if ($("#hfNodeGuid").length == 0 || $(".lotmap").length == 0) {
//         return;
//     }

//     // Get the hidden field
//     var nodeGuid = $("#hfNodeGuid").val();

//     if (nodeGuid == null || nodeGuid.length < 1) {
//         return;
//     }

//     $.ajaxSetup({
//         async: true
//     });
//     var lotMap = $("#divLotmap");
//     // Init the lot map helper and load the SVG
//     LotMapHelper.init(nodeGuid, lotMap);
//     LotMapHelper.loadSVG(null);

// }

/**
 * @deprecated see 'LotMap` in `/lib/lot-map.js` and `CommunitySitemap` in `community-sitemap.js`
 * 
 * Handles the initialization of the Community Lot Map
 */
// function initCommunitySitemapWebpart() {
//     // First check for existence of hidden field that marks a Community Lot Map existence
//     if ($("#hfCommunitySitemapNodeGuid").length == 0 || $(".lotmap").length == 0) {
//         return;
//     }

//     // Get the hidden field
//     var nodeGuid = $("#hfCommunitySitemapNodeGuid").val();

//     if (nodeGuid == null || nodeGuid.length < 1) {
//         return;
//     }

//     $.ajaxSetup({
//         async: true
//     });
//     var lotMap = $("#divCommunitySitemap");
//     // Init the lot map helper and load the SVG
//     LotMapHelper.init(nodeGuid, lotMap);
//     LotMapHelper.loadSVG(null);

// }

/**
 * Initializes functionality regarding pillbox buttons
 */
function initPillboxButtons() {
    $('.form-input-container').on("click", '.button-pillbox.closeable', function () {
        var nextEl = $(this).next();
        $(this).remove();

        if (nextEl.length) {
            nextEl.focus();
        } else {
            // console.log("All communities options have been removed");
            var sibling = $(".pillbox-wrapper").nextAll('.form-input-container').first();

            $(document).keydown(function(e) {
                if (e.which == 9) {
                    e.preventDefault();
                    $(sibling).find('button, a, input, select, textarea').first().focus();
                    $(this).off(e);
                }
            });
        }
    });
}

window.initPillboxButtons = initPillboxButtons;

function stringContainsAny(string, arrayOfStrings) {
    var containsElemFromArray = false;
    if( string != null ) {
        arrayOfStrings.forEach(s => {
            if( string.indexOf(s) > -1 ) {
                containsElemFromArray = true;
            }
        });
    }

    return containsElemFromArray;
}
window.stringContainsAny = stringContainsAny;

/**
 * Due to reveal modals incorrectly shifting due to images
 * lazy loading as the reveal opens, manually trigger the loading of 
 * these images. Intended to be invoked after DOM ready
 * @param {elem} revealModal Reveal Modal element
 */
function triggerLazyLoadRevealImages(revealModal){
    // Do not force lazy load of videos because they will begin to autoplay
    var lazyImagesWithinRevealModals = $(revealModal).find(".lozad:not(video)");
    if (lazyImagesWithinRevealModals != null) {
        lazyImagesWithinRevealModals.each(function (index, lazyMedia) {
            lozadObserver.triggerLoad(lazyMedia);
        });
    }
}

window.triggerLazyLoadRevealImages = triggerLazyLoadRevealImages;

/**
 * Initializes PDF IFrame Modules 
 */
function initPdfIframeRenderers() {
    var pdfIframes = $(".pdf-iframe");

    $.each(pdfIframes, function (iframe, value) {
        var iframe = $(this);
        var hfIframeSrc = $(iframe.siblings(".hf-iframe-src")).val();
        var renderer = new RenderPdfIframeHelper(iframe, hfIframeSrc);
        var tabSection = $(iframe).parents().closest("section").find("ul.tabs").first();
        iFrameScrollPos = $(tabSection).position().top;

        // load content when we scroll into iframe section
        window.addEventListener('scroll', function (e) {
            if (window.location.hash) {  // See if we have a hash # in the URL
                if (!isScrollForIFrameSet) { // Only if this isn't set add the function to set the final position during onload
                    window.onload = iFrameScrollToPosition;
                }
            }
            else {
                renderer._last_known_scroll_position = window.scrollY;
            }

            window.requestAnimationFrame(function () {
                // If the browser is IE or Edge, load the iframe source when the user scrolled to that section.
                if (renderer._isIE || renderer._isEdge) {
                    renderer.loadIframeContent(renderer._last_known_scroll_position);
                }
            });
        });

        // If these are within Foundation tabs, listen to tab change to reload iframe
        // Needed because when tabs goes inactive, the iframe no longer renders the PDF
        // so we need to force reload it
        let tabPanelsElem = $(this).parents("[data-tabs-content]");
        let tabsId = tabPanelsElem.data("tabs-content");
        let tabsElem = $("#" + tabsId);

        let curTabPanel = $(this).parents(".tabs-panel");
        let curTabId = curTabPanel.attr("id");

        if ( tabsElem && tabsElem.length > 0) {
            tabsElem.on('change.zf.tabs', function (event, newTab) {
                var newtabId = newTab.find("a").attr("aria-controls");

                var forceReloadNewTab = ($(newTab).attr("data-force-reload") === "true");

                // For the newly activated tab, force reload the pdf 
                if (curTabId == newtabId && forceReloadNewTab){
                    renderer.processIframeUrl();

                }

                // Add attribute to this tab to signal we have force reloaded the PDF the next time we switch to this tab
                $(newTab).attr("data-force-reload", "true");

            });
        }
    });
}

/**
 * Render the PDF object html tags
 */
function initPdfObjectRenderers(){
    var pdfObjectElems = $(".pdf-object");
    $.each(pdfObjectElems, function(index, value){
        var objectElem = $(this);
        var hfIframeSrc = $(objectElem.siblings(".hf-iframe-src")).val();
        var renderer = new RenderPdfObjectHelper(objectElem, hfIframeSrc);

        // load content when we scroll into iframe section
        window.addEventListener('scroll', function (e) {
            renderer._last_known_scroll_position = window.scrollY;

            window.requestAnimationFrame(function () {

                // If the browser is IE or Edge, load the iframe source when the user scrolled to that section.
                if (renderer._isIE || renderer._isEdge) {
                    renderer.loadIframeContent(renderer._last_known_scroll_position);
                }
            });
        });

        // If these are within Foundation tabs, listen to tab change to reload iframe
        // Needed because when tabs goes inactive, the iframe no longer renders the PDF
        // so we need to force reload it
        let tabPanelsElem = $(this).parents("[data-tabs-content]");
        let tabsId = tabPanelsElem.data("tabs-content");
        let tabsElem = $("#" + tabsId);

        let curTabPanel = $(this).parents(".tabs-panel");
        let curTabId = curTabPanel.attr("id");


        if ( tabsElem && tabsElem.length > 0) {
            tabsElem.on('change.zf.tabs', function (event, newTab) {
                var newtabId = newTab.find("a").attr("aria-controls");

                var forceReloadNewTab = ($(newTab).attr("data-force-reload") === "true");

                // For the newly activated tab, force reload the pdf 
                if (curTabId == newtabId && forceReloadNewTab){
                    renderer.processIframeUrl();

                }

                // Add attribute to this tab to signal we have force reloaded the PDF the next time we switch to this tab
                $(newTab).attr("data-force-reload", "true");

            })
        }
    })
}

function iFrameScrollToPosition() {
    // Check screen size for proper scroll to setting
    if (Foundation.MediaQuery.atLeast('medium') === true) {
        window.scrollTo(0, iFrameScrollPos + IFRAME_SCROLL_OFFSET);  // For Desktop needs an offset
    }
    else {
        window.scrollTo(0, iFrameScrollPos); // For mobile
    }
    isScrollForIFrameSet = true; // Set this to true so it doesn't interfere when the user scrolls on the page
}

var $qmiJumpLink = $('a.home-card_content-move-ins'),
    duration = 1000;

$qmiJumpLink.on('click', function(e) {
    var that = $(this);  
    e.preventDefault();
    setTimeout(function(){
        window.location = that.attr('href');
    }, duration);
    
});

let qmiDrilldown = $('a[data-qmi-drilldown]'),
    qmiTimeout;

qmiDrilldown.on('click', function() {
    qmiTimeout = setTimeout(waitForDrilldown, 500);
});

function waitForDrilldown() {
    let qmiTab = $('#qmi-display-tab a');
    qmiTab.trigger('click');
    clearTimeout(qmiTimeout);
}

function initFrequentlyAskedQuestions(moduleElem) {
    var accordionElem = $((moduleElem).find(".accordion"));
    foundationWrapper(accordionElem);

    var userInfo = MshUser.getUserInfo();
    const CATEGORY_GENERAL = 'General';
    const CATEGORY_SHOPPER = 'Shoppers';
    const CATEGORY_BUYER = 'Buyers';
    const CATEGORY_OWNER = 'Owners';
    if (userInfo) {
        
        var isLoggedIn = userInfo.IsLoggedIn;
        var roles = userInfo.Roles;

        if (!isLoggedIn || roles.IsShopper) {
            // show all accordions aka do nothing if user is NOT logged in OR if they are a shopper
        }
        else if (roles.IsBuyer) {
            // show General, Buyer category
            $(moduleElem.find(`[data-faq-category='${CATEGORY_SHOPPER}'], [data-faq-category='${CATEGORY_OWNER}']`)).hide();
        }
        else if (roles.IsOwner || roles.IsResaleOwner) {
            // show General, Owner category
            $(moduleElem.find(`[data-faq-category='${CATEGORY_SHOPPER}'], [data-faq-category='${CATEGORY_BUYER}']`)).hide();
        }
    }
}
window.initFrequentlyAskedQuestions = initFrequentlyAskedQuestions;